<template>
  <modal
    name="RelatorioIAModal"
    class="relatorio-modal"
    :height="'auto'"
    :width="'80%'"
    :adaptive="true"
    :scrollable="true"
    @opened="onModalOpened()"
  >
    <section class="relatorio-modal-wrapper">
      <h3 class="title">
        <span>{{ $t('relatorio_modal_title') }}</span>
        <span v-if="isReportDeprecated" class="report-status-badge deprecated">
          {{ $t('deprecated') }}
        </span>
      </h3>

      <section v-if="loading || loadingCardapio" class="loading-container">
        <p>{{ loadingCardapio ? $t('regerar_cardapio_gerando') : $t('relatorio_gerando') }}</p>
      </section>

      <main v-else class="relatorio-content">
        <section v-if="hasError" class="no-data-container error">
          <figure class="no-data-icon">
            <i class="fas fa-exclamation-triangle"></i>
          </figure>
          <section class="no-data-content">
            <h4>{{ $t('relatorio_erro_titulo') }}</h4>
            <p>{{ errorMessage }}</p>
          </section>
        </section>

        <section v-else-if="!hasData" class="no-data-container">
          <figure class="no-data-icon">
            <i class="fas fa-chart-line"></i>
          </figure>
          <section class="no-data-content">
            <h4>{{ $t('relatorio_sem_dados_titulo') }}</h4>
            <p>{{ $t('relatorio_sem_dados_mensagem') }}</p>
          </section>
        </section>

        <section v-else>
          <section class="tabs">
            <nav class="tabs-header" aria-label="Relatorio tabs">
              <button
                class="tab-button"
                :class="{ active: activeTab === 'resumo' }"
                @click="activeTab = 'resumo'"
              >
                {{ $t('relatorio_tab_resumo') }}
              </button>
              <button
                class="tab-button"
                :class="{ active: activeTab === 'conformidade' }"
                @click="activeTab = 'conformidade'"
              >
                {{ $t('relatorio_tab_conformidade') }}
              </button>
              <button
                class="tab-button"
                :class="{ active: activeTab === 'problemas' }"
                @click="activeTab = 'problemas'"
              >
                {{ $t('relatorio_tab_problemas') }}
              </button>
              <!-- BOTÃO DE TAB "OUTROS" DESATIVADO -->
              <!-- <button class="tab-button" :class="{ active: activeTab === 'outros' }"
                                @click="activeTab = 'outros'">
                                {{ $t('relatorio_tab_outros') }}
                            </button> -->
            </nav>
            <section class="tabs-content">
              <section v-if="activeTab === 'resumo'" class="tab-pane">
                <section class="tab-section">
                  <h4>{{ $t('relatorio_info_titulo') }}</h4>
                  <section class="metadata-container">
                    <article class="metadata-item">
                      <span class="metadata-label">{{ $t('scenery') }}:</span>
                      <span
                        class="metadata-value"
                        >{{ metadata.scenario?.scenarioId ||
                                                $t('relatorio_sem_nome') }}</span
                      >
                    </article>
                    <article class="metadata-item">
                      <span class="metadata-label"
                        >{{ $t('relatorio_periodo') }}:</span
                      >
                      <span class="metadata-value">
                        {{ formatScenarioPeriod(metadata.scenario?.period) }}
                      </span>
                    </article>
                    <article class="metadata-item">
                      <span
                        class="metadata-label"
                        >{{ $t('generated_in') }}</span
                      >
                      <span class="metadata-value">{{
                                                formatDateTime(metadata.analysisMetadata?.generatedAt) }}</span>
                    </article>
                    <!-- <div class="metadata-item">
                                            <span class="metadata-label">{{ $t('relatorio_modelo_ia') }}:</span>
                                            <span class="metadata-value">{{ metadata.analysisMetadata?.aiModel }}</span>
                                        </div> -->
                  </section>
                </section>

                <section class="tab-section">
                  <h4>{{ $t('relatorio_score_titulo') }}</h4>
                  <section class="score-container">
                    <template v-if="showScoreComparison">
                      <div class="score-before-block">
                        <div class="score-label-context">{{ $t('before_IA') }}</div>
                        <div class="score-circle-before" :class="getScoreClass(scoreBeforeAI)">
                          <div class="score-value">{{ scoreBeforeAI }}</div>
                          <div class="score-label">{{ $t('relatorio_pontos') }}</div>
                        </div>
                        <div class="score-before-subtitle">{{ $t('original_menu') }}</div>
                      </div>
                      <div class="score-arrow-block">
                        <span class="score-arrow">→</span>
                        <span class="score-delta">+{{ scoreDelta }} pts</span>
                      </div>
                    </template>
                    <div
                      class="score-circle"
                      :class="getScoreClass(summary.overallScore)"
                    >
                      <div class="score-value">{{ summary.overallScore }}</div>
                      <div class="score-label">
                        {{ $t('relatorio_pontos') }}
                      </div>
                    </div>
                    <section class="score-details">
                      <header class="quality-level">
                        <span class="quality-label"
                          >{{ $t('relatorio_nivel_qualidade')

                          }}:</span
                        >
                        <span
                          class="quality-value"
                          :class="getDictionary(summary.qualityLevel, 'qualityLevel', 'class')"
                        >
                          {{ getDictionary(summary.qualityLevel, 'qualityLevel') }}
                        </span>
                        <span v-if="showIAnotImprove" class="report-status-badge deprecated">
                          {{ $t('not_improved_by_IA') }}
                        </span>
                        <button
                          v-if="showScoreComparison"
                          type="button"
                          class="clear-highlights-btn"
                          @click="highlightSolverCells"
                        >
                        {{ $t('highlight_IA_improvements') }}
                        </button>
                        <button
                        v-if="showScoreComparison"
                        type="button"
                        class="clear-highlights-btn"
                        @click="clearMenuHighlights"
                      >
                        {{ $t('relatorio_limpar_destaques') }}
                      </button>
                      </header>
                      <div class="summary-text">
                        {{ summary.summaryText }}
                      </div>
                    </section>
                  </section>
                </section>

                <section class="tab-section">
                  <h4>{{ $t('relatorio_problemas_titulo') }}</h4>
                  <section class="issues-summary">
                    <article class="issue-count critical">
                      <div class="issue-count-number">
                        {{ summary.criticalIssuesCount || 0 }}
                      </div>
                      <div class="issue-count-label">
                        {{ $t('relatorio_criticos') }}
                      </div>
                    </article>
                    <article class="issue-count medium">
                      <div class="issue-count-number">
                        {{ summary.mediumIssuesCount || 0 }}
                      </div>
                      <div class="issue-count-label">
                        {{ $t('relatorio_medios') }}
                      </div>
                    </article>
                    <article class="issue-count low">
                      <div class="issue-count-number">
                        {{ summary.lowIssuesCount || 0 }}
                      </div>
                      <div class="issue-count-label">
                        {{ $t('relatorio_baixos') }}
                      </div>
                    </article>
                  </section>
                </section>
              </section>

              <section v-if="activeTab === 'problemas'" class="tab-pane">
                <section class="detailed-analysis">
                  <section v-if="hasIssues" class="analysis-section">
                    <header class="section-header">
                      <h4>
                        <i class="fas fa-exclamation-circle"></i>
                        {{ $t('relatorio_problemas_identificados') }}
                        <span
                          class="counter-badge"
                          >{{ relatorioData.issues.length }}</span
                        >
                      </h4>
                    </header>
                    <section class="highlight-legend-toolbar">
                      <div class="highlight-legend">
                        <span class="legend-title"
                          >{{ $t('relatorio_legenda_highlight')

                          }}:</span
                        >
                        <span class="legend-item legend-usage">{{
                                                    $t('relatorio_legenda_utilizacao') }}</span>
                        <span class="legend-item legend-candidate">{{
                                                    $t('relatorio_legenda_oportunidade') }}</span>
                        <span class="legend-item legend-conflict">{{
                                                    $t('relatorio_legenda_conflito') }}</span>
                      </div>
                      <button
                        type="button"
                        class="clear-highlights-btn"
                        @click="clearMenuHighlights"
                      >
                        {{ $t('relatorio_limpar_destaques') }}
                      </button>
                    </section>
                    <section class="items-list">
                      <article
                        v-for="(issue, issueIndex) in relatorioData.issues"
                        :key="getIssueKey(issue, issueIndex)"
                        :data-issue-key="getIssueKey(issue, issueIndex)"
                        class="list-item"
                        :class="getDictionary(issue.severity, 'severity', 'class')"
                      >
                        <button
                          type="button"
                          class="issue-accordion-header"
                          @click="toggleIssue(getIssueKey(issue, issueIndex), issue, issueIndex)"
                        >
                          <div class="item-header">
                            <div
                              class="item-icon"
                              :class="getDictionary(issue.severity, 'severity', 'class')"
                            >
                              <i
                                class="fas fa-fw"
                                :class="getDictionary(issue.severity, 'severity', 'icon')"
                              ></i>
                            </div>
                            <div class="item-content">
                              <div class="item-title">{{ issue.title }}</div>
                              <div class="item-description">
                                {{ getIssueDescription(issue)
                                }}
                              </div>
                            </div>
                          </div>
                          <div class="issue-header-right">
                            <span
                              v-if="hasEntities(issue)"
                              class="entity-badge"
                            >
                              {{ getEntitiesCount(issue) }}
                              <!-- {{$t('relatorio_entidades_afetadas') }} -->
                            </span>
                            <span
                              class="accordion-chevron"
                              :key="`issue-chevron-${getIssueKey(issue, issueIndex)}-${isIssueExpanded(getIssueKey(issue, issueIndex)) ? 'open' : 'closed'}`"
                              :title="isIssueExpanded(getIssueKey(issue, issueIndex)) ? $t('relatorio_recolher') : $t('relatorio_expandir')"
                              :aria-label="isIssueExpanded(getIssueKey(issue, issueIndex)) ? $t('relatorio_recolher') : $t('relatorio_expandir')"
                            >
                              <i
                                class="fas"
                                :class="isIssueExpanded(getIssueKey(issue, issueIndex)) ? 'fa-chevron-down' : 'fa-chevron-right'"
                              ></i>
                            </span>
                          </div>
                        </button>

                        <section
                          v-if="isIssueExpanded(getIssueKey(issue, issueIndex))"
                          class="issue-accordion-body"
                        >
                          <section
                            v-if="isR3Issue(issue) && hasR3GroupedEntities(issue)"
                            class="entity-list"
                          >
                            <article
                              v-for="group in getR3EntityGroups(issue)"
                              :key="`${getIssueKey(issue, issueIndex)}-r3-group-${group.groupKey}`"
                              class="entity-card entity-card-collapsible"
                            >
                              <button
                                type="button"
                                class="entity-accordion-header"
                                @click="toggleR3Group(issue, issueIndex, group.groupKey)"
                              >
                                <div class="entity-accordion-title">
                                  {{ group.label }}
                                </div>
                                <div class="entity-accordion-right">
                                  <span
                                    class="entity-badge"
                                    >{{ group.entities.length
                                    }}</span
                                  >
                                  <span
                                    class="accordion-chevron"
                                    :key="`r3-chevron-${getR3GroupStorageKey(issue, issueIndex, group.groupKey)}-${isR3GroupExpanded(issue, issueIndex, group.groupKey) ? 'open' : 'closed'}`"
                                  >
                                    <i
                                      class="fas"
                                      :class="isR3GroupExpanded(issue, issueIndex, group.groupKey) ? 'fa-chevron-down' : 'fa-chevron-right'"
                                    ></i>
                                  </span>
                                </div>
                              </button>

                              <section
                                v-if="isR3GroupExpanded(issue, issueIndex, group.groupKey)"
                                class="entity-card-body"
                              >
                                <section class="r3-group-entities">
                                  <article
                                    v-for="(entity, entityIndex) in group.entities"
                                    :key="`${getIssueKey(issue, issueIndex)}-${group.groupKey}-entity-${entityIndex}`"
                                    class="entity-card r3-entity-card"
                                  >
                                    <section
                                      class="entity-card-body entity-display-r3-repetition"
                                    >
                                      <div class="entity-grid r3-summary-grid">
                                        <div
                                          v-if="isR3ByTypeEntity(entity)"
                                          class="entity-line"
                                        >
                                          <strong
                                            >{{
                                                                                        $t('relatorio_entidade_tipo')

                                            }}:</strong
                                          >
                                          <span>{{ entity.tipo || '-'
                                          }}</span>
                                        </div>
                                        <div class="entity-line">
                                          <strong>{{ $t('date') }}:</strong>
                                          <span>{{
                                                                                        formatDate(entity.date)
                                          }}</span>
                                        </div>
                                      </div>

                                      <div
                                        v-if="buildR3Tags(entity).length || getR3EntityActions(entity).length"
                                        class="r3-tags-actions-row"
                                      >
                                        <div
                                          v-if="buildR3Tags(entity).length"
                                          class="entity-tags r3-tags-row"
                                        >
                                          <template
                                            v-for="(tag, tagIndex) in buildR3Tags(entity)"
                                          >
                                            <button
                                              v-if="isActionableTag(tag)"
                                              type="button"
                                              class="entity-tag entity-tag-action"
                                              :key="`${issueIndex}-${group.groupKey}-${entityIndex}-tag-btn-${tagIndex}`"
                                              @click.stop="handleTagAction(tag, issue, entity)"
                                            >
                                              {{ getTagLabel(tag) }}
                                            </button>
                                            <span
                                              v-else
                                              class="entity-tag"
                                              :key="`${issueIndex}-${group.groupKey}-${entityIndex}-tag-txt-${tagIndex}`"
                                            >
                                              {{ getTagLabel(tag) }}
                                            </span>
                                          </template>
                                        </div>

                                        <div
                                          v-if="getR3EntityActions(entity).length"
                                          class="entity-actions r3-actions-row"
                                        >
                                          <button
                                            v-for="(action, actionIndex) in getR3EntityActions(entity)"
                                            :key="`${issueIndex}-${group.groupKey}-${entityIndex}-action-${actionIndex}`"
                                            type="button"
                                            class="navigate-btn"
                                            :class="getActionButtonClass(action)"
                                            @click="handleEntityAction(action, issue, entity)"
                                          >
                                            {{ getActionLabel(action) }}
                                          </button>
                                        </div>
                                      </div>
                                    </section>
                                  </article>
                                </section>
                              </section>
                            </article>
                          </section>

                          <section
                            v-else-if="isR8Issue(issue) && hasR8GroupedEntities(issue)"
                            class="entity-list"
                          >
                            <article
                              v-for="group in getR8EntityGroups(issue)"
                              :key="`${getIssueKey(issue, issueIndex)}-r8-group-${group.groupKey}`"
                              class="entity-card entity-card-collapsible"
                            >
                              <button
                                type="button"
                                class="entity-accordion-header"
                                @click="toggleR8Group(issue, issueIndex, group.groupKey)"
                              >
                                <div class="entity-accordion-title">
                                  {{ group.label }}
                                </div>
                                <div class="entity-accordion-right">
                                  <span
                                    class="entity-badge"
                                    >{{ group.entities.length
                                    }}</span
                                  >
                                  <span
                                    class="accordion-chevron"
                                    :key="`r8-chevron-${getR8GroupStorageKey(issue, issueIndex, group.groupKey)}-${isR8GroupExpanded(issue, issueIndex, group.groupKey) ? 'open' : 'closed'}`"
                                  >
                                    <i
                                      class="fas"
                                      :class="isR8GroupExpanded(issue, issueIndex, group.groupKey) ? 'fa-chevron-down' : 'fa-chevron-right'"
                                    ></i>
                                  </span>
                                </div>
                              </button>
                              <section
                                v-if="isR8GroupExpanded(issue, issueIndex, group.groupKey)"
                                class="entity-card-body"
                              >
                                <section class="r8-group-entities">
                                  <article
                                    v-for="(entity, entityIndex) in group.entities"
                                    :key="`${getIssueKey(issue, issueIndex)}-${group.groupKey}-entity-${entityIndex}`"
                                    class="entity-card r8-entity-card"
                                  >
                                    <section class="entity-card-body">
                                      <div
                                        v-if="getEntityView(issue, entity).fallback"
                                        class="entity-fallback"
                                      >
                                        <p>
                                          {{ $t('relatorio_entidade_fallback')
                                          }}
                                        </p>
                                        <pre>{{ stringifyEntity(entity) }}</pre>
                                      </div>

                                      <div
                                        v-else-if="isR3Entity(issue, entity)"
                                        class="entity-display-r3-repetition"
                                      >
                                        <div
                                          class="entity-grid r3-summary-grid"
                                        >
                                          <div
                                            v-for="(row, rowIndex) in getEntityView(issue, entity).rows"
                                            :key="`${issueIndex}-${group.groupKey}-${entityIndex}-r3-row-${rowIndex}`"
                                            class="entity-line"
                                            :class="{
                                                                                            'entity-line-usage': row.type === 'usage',
                                                                                            'entity-line-entity': row.type === 'entity',
                                                                                            'entity-line-single-line': row.singleLine
                                                                                        }"
                                          >
                                            <strong
                                              >{{ row.label

                                              }}:</strong
                                            >
                                            <template
                                              v-if="row.type === 'entity'"
                                            >
                                              <div
                                                class="entity-value-entity"
                                                :class="{ 'entity-value-entity-single-line': row.singleLine }"
                                              >
                                                <span
                                                  v-if="row.code"
                                                  class="entity-code-chip"
                                                  :title="row.code"
                                                >
                                                  {{ row.code }}
                                                </span>
                                                <span
                                                  class="entity-value-name"
                                                  :class="{ 'entity-value-name-single-line': row.singleLine }"
                                                  :title="row.nameTitle || row.name || '-'"
                                                  >{{
                                                                                                        row.name || '-'
                                                  }}</span
                                                >
                                              </div>
                                            </template>
                                            <template
                                              v-else-if="row.type === 'usage'"
                                            >
                                              <div class="entity-usage-metrics">
                                                <span class="group-usage-chip">
                                                  {{
                                                                                                        $t('relatorio_utilizado')

                                                  }}:
                                                  {{
                                                                                                        row.usage.used }}
                                                </span>
                                                <span class="group-usage-chip">
                                                  {{
                                                                                                        $t('relatorio_minimo')

                                                  }}:
                                                  {{
                                                                                                        row.usage.min }}
                                                </span>
                                                <span class="group-usage-chip">
                                                  {{
                                                                                                        $t('relatorio_maximo')

                                                  }}:
                                                  {{
                                                                                                        row.usage.max }}
                                                </span>
                                                <span
                                                  v-if="row.usage.delta !== null"
                                                  class="group-usage-chip"
                                                >
                                                  {{
                                                                                                        $t('relatorio_diferenca')

                                                  }}:
                                                  {{
                                                                                                        row.usage.delta }}
                                                </span>
                                              </div>
                                            </template>
                                            <template v-else>
                                              <span
                                                :class="{ 'entity-text-value-single-line': row.singleLine }"
                                                :title="row.valueTitle || row.value || '-'"
                                                >{{ row.value }}</span
                                              >
                                            </template>
                                          </div>
                                        </div>

                                        <div
                                          v-if="getEntityView(issue, entity).tags.length || getEntityView(issue, entity).actions.length"
                                          class="r3-tags-actions-row"
                                        >
                                          <div
                                            v-if="getEntityView(issue, entity).tags.length"
                                            class="entity-tags r3-tags-row"
                                          >
                                            <template
                                              v-for="(tag, tagIndex) in getEntityView(issue, entity).tags"
                                            >
                                              <button
                                                v-if="isActionableTag(tag)"
                                                type="button"
                                                class="entity-tag entity-tag-action"
                                                :key="`${issueIndex}-${group.groupKey}-${entityIndex}-r3-tag-btn-${tagIndex}`"
                                                @click.stop="handleTagAction(tag, issue, entity)"
                                              >
                                                {{ getTagLabel(tag) }}
                                              </button>
                                              <span
                                                v-else
                                                class="entity-tag"
                                                :key="`${issueIndex}-${group.groupKey}-${entityIndex}-r3-tag-txt-${tagIndex}`"
                                              >
                                                {{ getTagLabel(tag) }}
                                              </span>
                                            </template>
                                          </div>

                                          <div
                                            v-if="getEntityView(issue, entity).actions.length"
                                            class="entity-actions r3-actions-row"
                                          >
                                            <button
                                              v-for="(action, actionIndex) in getEntityView(issue, entity).actions"
                                              :key="`${issueIndex}-${group.groupKey}-${entityIndex}-r3-action-${actionIndex}`"
                                              type="button"
                                              class="navigate-btn"
                                              :class="getActionButtonClass(action)"
                                              @click="handleEntityAction(action, issue, entity)"
                                            >
                                              {{ getActionLabel(action) }}
                                            </button>
                                          </div>
                                        </div>
                                      </div>

                                      <div
                                        v-else
                                        :class="['entity-display', { 'entity-display-r1-frequency': isR1Entity(issue, entity), 'entity-display-r3-repetition': isR3Entity(issue, entity), 'entity-display-r8-unmet': isR8UnmetEntity(issue, entity), 'entity-display-r10-gap': isR10Entity(issue, entity), 'entity-display-r9-conflict': isR9Entity(issue, entity) }]"
                                      >
                                        <div class="entity-grid">
                                          <div
                                            v-for="(row, rowIndex) in getEntityView(issue, entity).rows"
                                            :key="`${issueIndex}-${group.groupKey}-${entityIndex}-row-${rowIndex}`"
                                            class="entity-line"
                                            :class="{
                                                                                            'entity-line-usage': row.type === 'usage',
                                                                                            'entity-line-entity': row.type === 'entity',
                                                                                            'entity-line-single-line': row.singleLine
                                                                                        }"
                                          >
                                            <strong
                                              >{{ row.label

                                              }}:</strong
                                            >
                                            <template
                                              v-if="row.type === 'entity'"
                                            >
                                              <div
                                                class="entity-value-entity"
                                                :class="{ 'entity-value-entity-single-line': row.singleLine }"
                                              >
                                                <span
                                                  v-if="row.code"
                                                  class="entity-code-chip"
                                                  :title="row.code"
                                                >
                                                  {{ row.code }}
                                                </span>
                                                <span
                                                  class="entity-value-name"
                                                  :class="{ 'entity-value-name-single-line': row.singleLine }"
                                                  :title="row.nameTitle || row.name || '-'"
                                                  >{{
                                                                                                        row.name || '-'
                                                  }}</span
                                                >
                                              </div>
                                            </template>
                                            <template
                                              v-else-if="row.type === 'usage'"
                                            >
                                              <div class="entity-usage-metrics">
                                                <span class="group-usage-chip">
                                                  {{
                                                                                                        $t('relatorio_utilizado')

                                                  }}:
                                                  {{
                                                                                                        row.usage.used }}
                                                </span>
                                                <span class="group-usage-chip">
                                                  {{
                                                                                                        $t('relatorio_minimo')

                                                  }}:
                                                  {{
                                                                                                        row.usage.min }}
                                                </span>
                                                <span class="group-usage-chip">
                                                  {{
                                                                                                        $t('relatorio_maximo')

                                                  }}:
                                                  {{
                                                                                                        row.usage.max }}
                                                </span>
                                                <span
                                                  v-if="row.usage.delta !== null"
                                                  class="group-usage-chip"
                                                >
                                                  {{
                                                                                                        $t('relatorio_diferenca')

                                                  }}:
                                                  {{
                                                                                                        row.usage.delta }}
                                                </span>
                                              </div>
                                            </template>
                                            <template v-else>
                                              <span
                                                :class="{ 'entity-text-value-single-line': row.singleLine }"
                                                :title="row.valueTitle || row.value || '-'"
                                                >{{ row.value }}</span
                                              >
                                            </template>
                                          </div>
                                        </div>

                                        <div
                                          v-if="getEntityView(issue, entity).tags.length"
                                          class="entity-tags"
                                        >
                                          <template
                                            v-for="(tag, tagIndex) in getEntityView(issue, entity).tags"
                                          >
                                            <button
                                              v-if="isActionableTag(tag)"
                                              type="button"
                                              class="entity-tag entity-tag-action"
                                              :key="`${issueIndex}-${group.groupKey}-${entityIndex}-tag-btn-${tagIndex}`"
                                              @click.stop="handleTagAction(tag, issue, entity)"
                                            >
                                              {{ getTagLabel(tag) }}
                                            </button>
                                            <span
                                              v-else
                                              class="entity-tag"
                                              :key="`${issueIndex}-${group.groupKey}-${entityIndex}-tag-txt-${tagIndex}`"
                                            >
                                              {{ getTagLabel(tag) }}
                                            </span>
                                          </template>
                                        </div>

                                        <div
                                          v-if="getEntityView(issue, entity).lines.length"
                                          class="entity-lines"
                                        >
                                          <div
                                            v-for="(line, lineIndex) in getEntityView(issue, entity).lines"
                                            :key="`${issueIndex}-${group.groupKey}-${entityIndex}-line-${lineIndex}`"
                                            class="entity-line"
                                            :class="{ 'entity-line-group-usage': line.type === 'group-usage' }"
                                          >
                                            <template
                                              v-if="line.type === 'group-usage'"
                                            >
                                              <div class="group-usage-header">
                                                <span class="group-name">{{
                                                                                                        line.name || '-'
                                                }}</span>
                                              </div>
                                              <div class="group-usage-metrics">
                                                <span
                                                  class="group-usage-scope"
                                                  >{{
                                                                                                        line.scope }}</span
                                                >
                                                <span class="group-usage-chip">
                                                  {{
                                                                                                        $t('relatorio_utilizado')

                                                  }}:
                                                  {{
                                                                                                        line.used }}
                                                </span>
                                                <span class="group-usage-chip">
                                                  {{
                                                                                                        $t('relatorio_minimo')

                                                  }}:
                                                  {{
                                                                                                        line.min }}
                                                </span>
                                                <span class="group-usage-chip">
                                                  {{
                                                                                                        $t('relatorio_maximo')

                                                  }}:
                                                  {{
                                                                                                        line.max }}
                                                </span>
                                                <span
                                                  v-if="line.delta !== null"
                                                  class="group-usage-chip"
                                                >
                                                  {{
                                                                                                        $t('relatorio_diferenca')

                                                  }}:
                                                  {{
                                                                                                        line.delta }}
                                                </span>
                                              </div>
                                              <div
                                                v-if="line.actions && line.actions.length"
                                                class="group-usage-actions"
                                              >
                                                <button
                                                  v-for="(lineAction, lineActionIndex) in line.actions"
                                                  :key="`${issueIndex}-${group.groupKey}-${entityIndex}-line-${lineIndex}-action-${lineActionIndex}`"
                                                  type="button"
                                                  class="navigate-btn"
                                                  :class="getActionButtonClass(lineAction)"
                                                  @click="handleEntityAction(lineAction, issue, entity)"
                                                >
                                                  {{
                                                                                                        getActionLabel(lineAction)
                                                  }}
                                                </button>
                                              </div>
                                            </template>
                                            <template
                                              v-else-if="line.type === 'occurrence'"
                                            >
                                              <div class="group-usage-metrics">
                                                <span class="group-usage-chip">
                                                  {{ $t('date') }}:
                                                  {{
                                                                                                        line.date
                                                  }}
                                                </span>
                                                <span class="group-usage-chip">
                                                  {{
                                                                                                        $t('relatorio_entidade_coluna')

                                                  }}:
                                                  {{
                                                                                                        line.sequencial }}
                                                </span>
                                              </div>
                                              <button
                                                v-if="line.action"
                                                type="button"
                                                class="navigate-btn"
                                                :class="getActionButtonClass(line.action)"
                                                @click="handleLineAction(line, issue, entity)"
                                              >
                                                {{
                                                                                                    getActionLabel(line.action)
                                                }}
                                              </button>
                                            </template>
                                            <template v-else>
                                              <span>{{ line.text }}</span>
                                              <button
                                                v-if="line.action"
                                                type="button"
                                                class="navigate-btn"
                                                :class="getActionButtonClass(line.action)"
                                                @click="handleLineAction(line, issue, entity)"
                                              >
                                                {{
                                                                                                    getActionLabel(line.action)
                                                }}
                                              </button>
                                            </template>
                                          </div>
                                        </div>

                                        <div
                                          v-if="getEntityView(issue, entity).actions.length"
                                          class="entity-actions"
                                        >
                                          <button
                                            v-for="(action, actionIndex) in getEntityView(issue, entity).actions"
                                            :key="`${issueIndex}-${group.groupKey}-${entityIndex}-action-${actionIndex}`"
                                            type="button"
                                            class="navigate-btn"
                                            :class="getActionButtonClass(action)"
                                            @click="handleEntityAction(action, issue, entity)"
                                          >
                                            {{ getActionLabel(action) }}
                                          </button>
                                        </div>
                                      </div>
                                    </section>
                                  </article>
                                </section>
                              </section>
                            </article>
                          </section>

                          <div
                            v-else-if="hasEntities(issue)"
                            class="entity-list"
                          >
                            <div
                              v-for="(entity, entityIndex) in getVisibleEntities(issue)"
                              :key="`${issue.issueId || issueIndex}-entity-${entityIndex}`"
                              class="entity-card"
                              :class="{ 'entity-card-collapsible': isR2Entity(issue, entity) }"
                            >
                              <button
                                v-if="isR2Entity(issue, entity)"
                                type="button"
                                class="entity-accordion-header"
                                @click="toggleR2Entity(issue, issueIndex, entity, entityIndex)"
                              >
                                <div class="entity-accordion-title">
                                  {{ formatCategory(entity.category) }}
                                </div>
                                <div class="entity-accordion-right">
                                  <span
                                    class="entity-badge"
                                    >{{ entity.count || 0
                                    }}</span
                                  >
                                  <span
                                    class="accordion-chevron"
                                    :key="`r2-chevron-${getR2EntityKey(issue, issueIndex, entity, entityIndex)}-${isR2EntityExpanded(issue, issueIndex, entity, entityIndex) ? 'open' : 'closed'}`"
                                  >
                                    <i
                                      class="fas"
                                      :class="isR2EntityExpanded(issue, issueIndex, entity, entityIndex) ? 'fa-chevron-down' : 'fa-chevron-right'"
                                    ></i>
                                  </span>
                                </div>
                              </button>

                              <div
                                v-if="!isR2Entity(issue, entity) || isR2EntityExpanded(issue, issueIndex, entity, entityIndex)"
                                class="entity-card-body"
                              >
                                <div
                                  v-if="getEntityView(issue, entity).fallback"
                                  class="entity-fallback"
                                >
                                  <p>{{ $t('relatorio_entidade_fallback') }}</p>
                                  <pre>{{ stringifyEntity(entity) }}</pre>
                                </div>

                                <div
                                  v-else-if="isR3Entity(issue, entity)"
                                  class="entity-display-r3-repetition"
                                >
                                  <div class="entity-grid r3-summary-grid">
                                    <div
                                      v-for="(row, rowIndex) in getEntityView(issue, entity).rows"
                                      :key="`${issueIndex}-${entityIndex}-r3-row-${rowIndex}`"
                                      class="entity-line"
                                      :class="{
                                                                                'entity-line-usage': row.type === 'usage',
                                                                                'entity-line-entity': row.type === 'entity',
                                                                                'entity-line-single-line': row.singleLine
                                                                            }"
                                    >
                                      <strong>{{ row.label }}:</strong>
                                      <template v-if="row.type === 'entity'">
                                        <div
                                          class="entity-value-entity"
                                          :class="{ 'entity-value-entity-single-line': row.singleLine }"
                                        >
                                          <span
                                            v-if="row.code"
                                            class="entity-code-chip"
                                            :title="row.code"
                                          >
                                            {{ row.code }}
                                          </span>
                                          <span
                                            class="entity-value-name"
                                            :class="{ 'entity-value-name-single-line': row.singleLine }"
                                            :title="row.nameTitle || row.name || '-'"
                                            >{{
                                                                                            row.name || '-' }}</span
                                          >
                                        </div>
                                      </template>
                                      <template
                                        v-else-if="row.type === 'usage'"
                                      >
                                        <div class="entity-usage-metrics">
                                          <span class="group-usage-chip">
                                            {{ $t('relatorio_utilizado') }}:
                                            {{
                                                                                            row.usage.used }}
                                          </span>
                                          <span class="group-usage-chip">
                                            {{ $t('relatorio_minimo') }}:
                                            {{
                                                                                            row.usage.min }}
                                          </span>
                                          <span class="group-usage-chip">
                                            {{ $t('relatorio_maximo') }}:
                                            {{
                                                                                            row.usage.max }}
                                          </span>
                                          <span
                                            v-if="row.usage.delta !== null"
                                            class="group-usage-chip"
                                          >
                                            {{ $t('relatorio_diferenca') }}:
                                            {{
                                                                                            row.usage.delta }}
                                          </span>
                                        </div>
                                      </template>
                                      <template v-else>
                                        <span
                                          :class="{ 'entity-text-value-single-line': row.singleLine }"
                                          :title="row.valueTitle || row.value || '-'"
                                          >{{ row.value }}</span
                                        >
                                      </template>
                                    </div>
                                  </div>

                                  <div
                                    v-if="getEntityView(issue, entity).tags.length || getEntityView(issue, entity).actions.length"
                                    class="r3-tags-actions-row"
                                  >
                                    <div
                                      v-if="getEntityView(issue, entity).tags.length"
                                      class="entity-tags r3-tags-row"
                                    >
                                      <template
                                        v-for="(tag, tagIndex) in getEntityView(issue, entity).tags"
                                      >
                                        <button
                                          v-if="isActionableTag(tag)"
                                          type="button"
                                          class="entity-tag entity-tag-action"
                                          :key="`${issueIndex}-${entityIndex}-r3-tag-btn-${tagIndex}`"
                                          @click.stop="handleTagAction(tag, issue, entity)"
                                        >
                                          {{ getTagLabel(tag) }}
                                        </button>
                                        <span
                                          v-else
                                          class="entity-tag"
                                          :key="`${issueIndex}-${entityIndex}-r3-tag-txt-${tagIndex}`"
                                        >
                                          {{ getTagLabel(tag) }}
                                        </span>
                                      </template>
                                    </div>

                                    <div
                                      v-if="getEntityView(issue, entity).actions.length"
                                      class="entity-actions r3-actions-row"
                                    >
                                      <button
                                        v-for="(action, actionIndex) in getEntityView(issue, entity).actions"
                                        :key="`${issueIndex}-${entityIndex}-r3-action-${actionIndex}`"
                                        type="button"
                                        class="navigate-btn"
                                        :class="getActionButtonClass(action)"
                                        @click="handleEntityAction(action, issue, entity)"
                                      >
                                        {{ getActionLabel(action) }}
                                      </button>
                                    </div>
                                  </div>
                                </div>

                                <div
                                  v-else
                                  :class="{ 'entity-display-r1-frequency': isR1Entity(issue, entity), 'entity-display-r3-repetition': isR3Entity(issue, entity), 'entity-display-r8-unmet': isR8UnmetEntity(issue, entity), 'entity-display-r10-gap': isR10Entity(issue, entity), 'entity-display-r9-conflict': isR9Entity(issue, entity) }"
                                >
                                  <div class="entity-grid">
                                    <div
                                      v-for="(row, rowIndex) in getEntityView(issue, entity).rows"
                                      :key="`${issueIndex}-${entityIndex}-row-${rowIndex}`"
                                      class="entity-line"
                                      :class="{
                                                                                'entity-line-usage': row.type === 'usage',
                                                                                'entity-line-entity': row.type === 'entity',
                                                                                'entity-line-single-line': row.singleLine
                                                                            }"
                                    >
                                      <strong>{{ row.label }}:</strong>
                                      <template v-if="row.type === 'entity'">
                                        <div
                                          class="entity-value-entity"
                                          :class="{ 'entity-value-entity-single-line': row.singleLine }"
                                        >
                                          <span
                                            v-if="row.code"
                                            class="entity-code-chip"
                                            :title="row.code"
                                          >
                                            {{ row.code }}
                                          </span>
                                          <span
                                            class="entity-value-name"
                                            :class="{ 'entity-value-name-single-line': row.singleLine }"
                                            :title="row.nameTitle || row.name || '-'"
                                            >{{
                                                                                            row.name || '-' }}</span
                                          >
                                        </div>
                                      </template>
                                      <template
                                        v-else-if="row.type === 'usage'"
                                      >
                                        <div class="entity-usage-metrics">
                                          <span class="group-usage-chip">
                                            {{ $t('relatorio_utilizado') }}:
                                            {{
                                                                                            row.usage.used }}
                                          </span>
                                          <span class="group-usage-chip">
                                            {{ $t('relatorio_minimo') }}:
                                            {{
                                                                                            row.usage.min }}
                                          </span>
                                          <span class="group-usage-chip">
                                            {{ $t('relatorio_maximo') }}:
                                            {{
                                                                                            row.usage.max }}
                                          </span>
                                          <span
                                            v-if="row.usage.delta !== null"
                                            class="group-usage-chip"
                                          >
                                            {{ $t('relatorio_diferenca') }}:
                                            {{
                                                                                            row.usage.delta }}
                                          </span>
                                        </div>
                                      </template>
                                      <template v-else>
                                        <span
                                          :class="{ 'entity-text-value-single-line': row.singleLine }"
                                          :title="row.valueTitle || row.value || '-'"
                                          >{{ row.value }}</span
                                        >
                                      </template>
                                    </div>
                                  </div>

                                  <div
                                    v-if="getEntityView(issue, entity).tags.length"
                                    class="entity-tags"
                                  >
                                    <template
                                      v-for="(tag, tagIndex) in getEntityView(issue, entity).tags"
                                    >
                                      <button
                                        v-if="isActionableTag(tag)"
                                        type="button"
                                        class="entity-tag entity-tag-action"
                                        :key="`${issueIndex}-${entityIndex}-tag-btn-${tagIndex}`"
                                        @click.stop="handleTagAction(tag, issue, entity)"
                                      >
                                        {{ getTagLabel(tag) }}
                                      </button>
                                      <span
                                        v-else
                                        class="entity-tag"
                                        :key="`${issueIndex}-${entityIndex}-tag-txt-${tagIndex}`"
                                      >
                                        {{ getTagLabel(tag) }}
                                      </span>
                                    </template>
                                  </div>

                                  <div
                                    v-if="getEntityView(issue, entity).lines.length"
                                    class="entity-lines"
                                  >
                                    <div
                                      v-for="(line, lineIndex) in getEntityView(issue, entity).lines"
                                      :key="`${issueIndex}-${entityIndex}-line-${lineIndex}`"
                                      class="entity-line"
                                      :class="{
                                                                                'entity-line-group-usage': line.type === 'group-usage',
                                                                                'entity-line-r5-details': line.type === 'r5-details',
                                                                                'entity-line-r9-summary': line.type === 'r9-summary',
                                                                                'entity-line-r9-details': line.type === 'r9-details',
                                                                                'entity-line-r4-details': line.type === 'r4-details'
                                                                            }"
                                    >
                                      <template
                                        v-if="line.type === 'group-usage'"
                                      >
                                        <div class="group-usage-header">
                                          <span class="group-name">{{
                                                                                        line.name || '-' }}</span>
                                        </div>
                                        <div class="group-usage-metrics">
                                          <span class="group-usage-scope">{{
                                                                                        line.scope }}</span>
                                          <span class="group-usage-chip">
                                            {{ $t('relatorio_utilizado') }}:
                                            {{
                                                                                            line.used }}
                                          </span>
                                          <span class="group-usage-chip">
                                            {{ $t('relatorio_minimo') }}:
                                            {{
                                                                                            line.min }}
                                          </span>
                                          <span class="group-usage-chip">
                                            {{ $t('relatorio_maximo') }}:
                                            {{
                                                                                            line.max }}
                                          </span>
                                          <span
                                            v-if="line.delta !== null"
                                            class="group-usage-chip"
                                          >
                                            {{ $t('relatorio_diferenca') }}:
                                            {{
                                                                                            line.delta }}
                                          </span>
                                        </div>
                                        <div
                                          v-if="line.actions && line.actions.length"
                                          class="group-usage-actions"
                                        >
                                          <button
                                            v-for="(lineAction, lineActionIndex) in line.actions"
                                            :key="`${issueIndex}-${entityIndex}-line-${lineIndex}-action-${lineActionIndex}`"
                                            type="button"
                                            class="navigate-btn"
                                            :class="getActionButtonClass(lineAction)"
                                            @click="handleEntityAction(lineAction, issue, entity)"
                                          >
                                            {{ getActionLabel(lineAction) }}
                                          </button>
                                        </div>
                                      </template>
                                      <template
                                        v-else-if="line.type === 'occurrence'"
                                      >
                                        <div class="group-usage-metrics">
                                          <span class="group-usage-chip">
                                            {{ $t('date') }}:
                                            {{ line.date
                                            }}
                                          </span>
                                          <span class="group-usage-chip">
                                            {{
                                                                                            $t('relatorio_entidade_coluna')

                                            }}: {{ line.sequencial }}
                                          </span>
                                        </div>
                                        <button
                                          v-if="line.action"
                                          type="button"
                                          class="navigate-btn"
                                          :class="getActionButtonClass(line.action)"
                                          @click="handleLineAction(line, issue, entity)"
                                        >
                                          {{ getActionLabel(line.action) }}
                                        </button>
                                      </template>
                                      <template
                                        v-else-if="line.type === 'r5-details'"
                                      >
                                        <div class="r5-details-layout">
                                          <div class="r5-details-grid">
                                            <div
                                              v-for="(item, itemIndex) in line.items"
                                              :key="`${issueIndex}-${entityIndex}-line-${lineIndex}-r5-item-${itemIndex}`"
                                              class="entity-line r5-detail-item"
                                            >
                                              <strong>{{ item.label }}:</strong>
                                              <span
                                                class="r5-detail-value"
                                                :title="item.valueTitle || item.value || '-'"
                                              >
                                                {{ item.value || '-' }}
                                              </span>
                                            </div>
                                            <button
                                              v-if="line.action"
                                              type="button"
                                              class="navigate-btn r5-details-action"
                                              :class="getActionButtonClass(line.action)"
                                              @click="handleLineAction(line, issue, entity)"
                                            >
                                              {{ getActionLabel(line.action) }}
                                            </button>
                                          </div>
                                        </div>
                                      </template>
                                      <template
                                        v-else-if="line.type === 'r9-summary'"
                                      >
                                        <div class="r9-summary-grid">
                                          <div
                                            v-for="(item, itemIndex) in line.items"
                                            :key="`${issueIndex}-${entityIndex}-line-${lineIndex}-summary-${itemIndex}`"
                                            class="entity-line r9-summary-item"
                                          >
                                            <strong
                                              >{{ item.label

                                              }}:</strong
                                            >
                                            <span>{{ item.value }}</span>
                                          </div>
                                        </div>
                                      </template>
                                      <template
                                        v-else-if="line.type === 'r9-details'"
                                      >
                                        <div class="r9-details-grid">
                                          <div
                                            v-for="(item, itemIndex) in line.items"
                                            :key="`${issueIndex}-${entityIndex}-line-${lineIndex}-details-${itemIndex}`"
                                            class="entity-line entity-line-entity entity-line-single-line r9-detail-item"
                                          >
                                            <strong
                                              >{{ item.label

                                              }}:</strong
                                            >
                                            <div
                                              class="entity-value-entity entity-value-entity-single-line"
                                            >
                                              <span
                                                v-if="item.code"
                                                class="entity-code-chip"
                                                :title="item.code"
                                              >
                                                {{ item.code }}
                                              </span>
                                              <span
                                                class="entity-value-name entity-value-name-single-line"
                                                :title="item.nameTitle || item.name || '-'"
                                              >
                                                {{ item.name || '-' }}
                                              </span>
                                            </div>
                                          </div>
                                          <button
                                            v-if="line.action"
                                            type="button"
                                            class="navigate-btn r9-details-action"
                                            :class="getActionButtonClass(line.action)"
                                            @click="handleLineAction(line, issue, entity)"
                                          >
                                            {{ getActionLabel(line.action)
                                            }}
                                          </button>
                                        </div>
                                      </template>
                                      <template
                                        v-else-if="line.type === 'r4-details'"
                                      >
                                        <div class="r4-details-grid">
                                          <div
                                            v-for="(item, itemIndex) in line.items"
                                            :key="`${issueIndex}-${entityIndex}-line-${lineIndex}-r4-${itemIndex}`"
                                            :class="[
                                                                                            'entity-line',
                                                                                            'r4-detail-item',
                                                                                            { 'entity-line-entity entity-line-single-line': item.type === 'entity' }
                                                                                        ]"
                                          >
                                            <strong
                                              >{{ item.label

                                              }}:</strong
                                            >
                                            <template
                                              v-if="item.type === 'entity'"
                                            >
                                              <div
                                                class="entity-value-entity entity-value-entity-single-line"
                                              >
                                                <span
                                                  v-if="item.code"
                                                  class="entity-code-chip"
                                                  :title="item.code"
                                                >
                                                  {{ item.code }}
                                                </span>
                                                <span
                                                  class="entity-value-name entity-value-name-single-line"
                                                  :title="item.nameTitle || item.name || '-'"
                                                >
                                                  {{ item.name || '-'
                                                  }}
                                                </span>
                                              </div>
                                            </template>
                                            <template v-else>
                                              <span
                                                class="r4-detail-value"
                                                :title="item.valueTitle || item.value || '-'"
                                              >
                                                {{ item.value || '-' }}
                                              </span>
                                            </template>
                                          </div>
                                          <button
                                            v-if="line.action"
                                            type="button"
                                            class="navigate-btn r4-details-action"
                                            :class="getActionButtonClass(line.action)"
                                            @click="handleLineAction(line, issue, entity)"
                                          >
                                            {{ getActionLabel(line.action)
                                            }}
                                          </button>
                                        </div>
                                      </template>
                                      <template v-else>
                                        <span>{{ line.text }}</span>
                                        <button
                                          v-if="line.action"
                                          type="button"
                                          class="navigate-btn"
                                          :class="getActionButtonClass(line.action)"
                                          @click="handleLineAction(line, issue, entity)"
                                        >
                                          {{ getActionLabel(line.action) }}
                                        </button>
                                      </template>
                                    </div>
                                  </div>

                                  <div
                                    v-if="getEntityView(issue, entity).actions.length"
                                    class="entity-actions"
                                  >
                                    <button
                                      v-for="(action, actionIndex) in getEntityView(issue, entity).actions"
                                      :key="`${issueIndex}-${entityIndex}-action-${actionIndex}`"
                                      type="button"
                                      class="navigate-btn"
                                      :class="getActionButtonClass(action)"
                                      @click="handleEntityAction(action, issue, entity)"
                                    >
                                      {{ getActionLabel(action) }}
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div v-else class="entity-empty">
                            {{ $t('relatorio_entidades_afetadas_vazio') }}
                          </div>
                        </section>
                      </article>
                    </section>
                  </section>

                  <div v-if="!hasIssues" class="no-data-message">
                    <i class="fas fa-check-circle"></i>
                    <p>{{ $t('relatorio_sem_analise_detalhada') }}</p>
                  </div>
                </section>
              </section>

              <section v-if="activeTab === 'conformidade'" class="tab-pane">
                <section class="detailed-analysis">
                  <section v-if="hasRuleCompliance" class="analysis-section">
                    <header class="section-header">
                      <h4>
                        <i class="fas fa-clipboard-check"></i>
                        {{ $t('relatorio_conformidade_regras') }}
                        <span class="counter-badge">
                          {{ compliantCount
                          }}/{{ relatorioData.ruleCompliance.length }}
                        </span>
                      </h4>
                    </header>
                    <section class="items-list">
                      <article
                        v-for="(rule, ruleIndex) in sortedRuleCompliance"
                        :key="`${rule.ruleId}-${ruleIndex}`"
                        class="list-item"
                        :class="getDictionary(rule.status, 'ruleStatus', 'class')"
                      >
                        <button
                          type="button"
                          class="rule-accordion-header"
                          @click="toggleRule(rule.ruleId, ruleIndex)"
                        >
                          <div class="item-header">
                            <div
                              class="item-icon"
                              :class="getDictionary(rule.status, 'ruleStatus', 'class')"
                            >
                              <i
                                class="fas fa-fw"
                                :class="getDictionary(rule.status, 'ruleStatus', 'icon')"
                              ></i>
                            </div>
                            <div class="item-content">
                              <div class="item-title">
                                {{ rule.ruleName || resolveRuleLabel(rule.ruleId) }}
                              </div>
                              <div class="item-description">
                                {{ rule.details ||
                                                                $t('relatorio_sem_detalhes') }}
                              </div>
                            </div>
                          </div>
                          <div class="issue-header-right">
                            <span
                              class="accordion-chevron"
                              :key="`rule-chevron-${rule.ruleId}-${ruleIndex}-${isRuleExpanded(rule.ruleId, ruleIndex) ? 'open' : 'closed'}`"
                              :title="isRuleExpanded(rule.ruleId, ruleIndex) ? $t('relatorio_recolher') : $t('relatorio_expandir')"
                              :aria-label="isRuleExpanded(rule.ruleId, ruleIndex) ? $t('relatorio_recolher') : $t('relatorio_expandir')"
                            >
                              <i
                                class="fas"
                                :class="isRuleExpanded(rule.ruleId, ruleIndex) ? 'fa-chevron-down' : 'fa-chevron-right'"
                              ></i>
                            </span>
                          </div>
                        </button>

                        <div
                          v-if="isRuleExpanded(rule.ruleId, ruleIndex)"
                          class="rule-accordion-body"
                        >
                          <div class="entity-grid">
                            <div class="entity-line">
                              <strong>{{ $t('relatorio_status') }}:</strong>
                              <span
                                >{{ getDictionary(rule.status, 'ruleStatus') }}</span
                              >
                            </div>
                            <div
                              v-if="rule.severityIfViolated"
                              class="entity-line"
                            >
                              <strong
                                >{{ $t('relatorio_severidade_se_violada')

                                }}:</strong
                              >
                              <span
                                >{{ getDictionary(rule.severityIfViolated, 'severity')
                                }}</span
                              >
                            </div>
                          </div>
                          <div class="entity-actions">
                            <button
                              v-if="hasIssueForRule(rule.ruleId)"
                              type="button"
                              class="navigate-btn"
                              @click="openIssueFromRule(rule.ruleId)"
                            >
                              {{ $t('relatorio_ir_para_problema') }}
                            </button>
                            <span v-else class="entity-empty">
                              {{ $t('relatorio_sem_problema_relacionado') }}
                            </span>
                          </div>
                        </div>
                      </article>
                    </section>
                  </section>

                  <div v-if="!hasRuleCompliance" class="no-data-message">
                    <i class="fas fa-check-circle"></i>
                    <p>{{ $t('relatorio_sem_analise_detalhada') }}</p>
                  </div>
                </section>
              </section>

              <section v-if="activeTab === 'outros'" class="tab-pane">
                <section class="other-analysis">
                  <section v-if="hasRecommendations" class="other-section">
                    <h4 class="section-title">
                      <i class="fas fa-lightbulb"></i>
                      {{ $t('relatorio_recomendacoes') }}
                    </h4>
                    <section class="other-list">
                      <article
                        v-for="rec in relatorioData.recommendations"
                        :key="rec.recommendationId"
                        class="other-item recommendation-item"
                      >
                        <section class="recommendation-content">
                          <div
                            class="recommendation-priority"
                            :class="getDictionary(rec.priority, 'priority', 'class')"
                          >
                            {{ getDictionary(rec.priority, 'priority') }}
                          </div>
                          <p class="recommendation-text">
                            {{ rec.description }}
                          </p>
                        </section>
                      </article>
                    </section>
                  </section>

                  <section v-if="hasKnowledgeSignals" class="other-section">
                    <h4 class="section-title">
                      <i class="fas fa-brain"></i>
                      {{ $t('relatorio_insights_ia') }}
                    </h4>
                    <section class="other-list">
                      <article
                        v-for="signal in relatorioData.knowledgeSignals"
                        :key="signal.signalType + signal.origin"
                        class="other-item signal-item"
                      >
                        <header class="signal-header">
                          <span
                            class="signal-type"
                            >{{ getDictionary(signal.signalType,
                                                        'signalType') }}</span
                          >
                        </header>
                        <p class="signal-description">
                          {{ signal.description }}
                        </p>
                      </article>
                    </section>
                  </section>

                  <div
                    v-if="!hasRecommendations && !hasKnowledgeSignals"
                    class="no-data-message"
                  >
                    <i class="fas fa-check-circle"></i>
                    <p>{{ $t('relatorio_sem_outros_dados') }}</p>
                  </div>
                </section>
              </section>
            </section>
          </section>
        </section>
      </main>

      <div class="modal-buttons">
        <p v-if="erroCardapio" class="cardapio-error-message">
          {{ erroCardapio }}
        </p>
        <div class="modal-buttons-row">
          <button type="button" class="button ghost" @click="fecharModal">
            <i class="fas fa-times"></i> {{ $t('Fechar') }}
          </button>
          <!--<button
            type="button"
            class="button ghost"
            @click="regerarCardapio"
            :disabled="loadingCardapio || loading"
          >
            <span
              class="relatorio-sync-icon-wrapper"
              :class="{ 'is-spinning': loadingCardapio }"
            >
              <i class="fas fa-wand-magic-sparkles relatorio-sync-icon"></i>
            </span>
            {{ loadingCardapio ? $t('relatorio_gerando_btn') : $t('regerar_cardapio') }}
          </button>-->
          <button
            type="button"
            class="button primary"
            @click="gerarRelatorio"
            :disabled="loading || loadingCardapio"
          >
            <span
              class="relatorio-sync-icon-wrapper"
              :class="{ 'is-spinning': loading }"
            >
              <i class="fas fa-sync-alt relatorio-sync-icon"></i>
            </span>
            {{ loading ? $t('relatorio_gerando_btn') : $t('relatorio_regerar') }}
          </button>
        </div>
      </div>
    </section>
  </modal>
</template>

<script>
import PlatesService from "@/application/services/Plates";
import moment from "moment";

const DICTIONARY = {
    qualityLevel: {
        'EXCELLENT': { text: 'Excelente', class: 'excellent' },
        'GOOD': { text: 'Bom', class: 'good' },
        'REGULAR': { text: 'Regular', class: 'regular' },
        'POOR': { text: 'Ruim', class: 'poor' }
    },
    severity: {
        'HIGH': { text: 'Crítico', class: 'critical', icon: 'fa-exclamation' },
        'MEDIUM': { text: 'Médio', class: 'medium', icon: 'fa-exclamation' },
        'LOW': { text: 'Baixo', class: 'low', icon: 'fa-exclamation' }
    },
    ruleStatus: {
        'COMPLIANT': { text: 'Conforme', class: 'compliant', icon: 'fa-check' },
        'VIOLATED': { text: 'Violada', class: 'violated', icon: 'fa-times' },
        'PARTIAL': { text: 'Parcial', class: 'partial', icon: 'fa-exclamation' }
    },
    priority: {
        'HIGH': { text: 'Alta', class: 'high' },
        'MEDIUM': { text: 'Média', class: 'medium' },
        'LOW': { text: 'Baixa', class: 'low' }
    },
    signalType: {
        'RULE_VIOLATION': 'Violação de Regra',
        'NEGATIVE_PATTERN': 'Padrão Negativo',
        'POSITIVE_PATTERN': 'Padrão Positivo',
        'OPPORTUNITY': 'Oportunidade',
        'RISK': 'Risco',
        'DATA_QUALITY': 'Qualidade de dados'
    }
};

const RULE_LABELS = {
    R1: 'Frequência de prato',
    R2: 'Frequência de grupo',
    R3: 'Não repetir no mesmo dia',
    R4: 'Ingredientes consecutivos',
    R5: 'Complexidade',
    R6: 'Pre-preparo',
    R7: 'Utilização do grupo',
    R8: 'Combinação obrigatória',
    R9: 'Combinação proibida',
    R10: 'Lacuna'
};

export default {
    name: "RelatorioIAModal",
    props: {
        scenarioId: {
            type: [String, Number],
            default: null
        },
        scenarioVersion: {
            type: [String, Number],
            default: null
        },
        dataCatalog: {
            type: Object,
            default: null
        },
        autoCloseOnNavigate: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            loading: false,
            activeTab: 'resumo',
            relatorioData: null,
            errorMessage: null,
            expandedIssues: {},
            expandedR2Entities: {},
            expandedR3Groups: {},
            expandedR8Groups: {},
            expandedRules: {},
            contextLoadStateByKey: {},
            requestInFlight: null,
            requestInFlightSilent: false,
            promotedSilentRequestToVisible: false,
            reportStatus: null,
            reportCurrentScenarioVersion: null,
            reportScenarioVersion: null,
            loadingCardapio: false,
            erroCardapio: null
        };
    },
    computed: {
        currentScenarioContextKey() {
            const normalizedScenarioId = this.normalizeContextValue(this.scenarioId);
            if (!normalizedScenarioId) return null;
            const normalizedVersion = this.normalizeContextValue(this.scenarioVersion) || 'no-version';
            return `${normalizedScenarioId}::${normalizedVersion}`;
        },
        metadata() {
            return this.relatorioData?.metadata || {};
        },
        summary() {
            return this.relatorioData?.summary || {};
        },
        scoreBeforeAI() {
            return this.dataCatalog?.quality?.scoreBeforeAI ?? 0;
        },
        showScoreComparison() {
            return this.scoreBeforeAI > 0 && this.summary.overallScore > this.scoreBeforeAI;
        },
        showIAnotImprove(){
          return this.scoreBeforeAI < 0;
        },
        scoreDelta() {
            return this.summary.overallScore - this.scoreBeforeAI;
        },
        hasIssues() {
            return this.relatorioData?.issues?.length > 0;
        },
        hasRuleCompliance() {
            return this.relatorioData?.ruleCompliance?.length > 0;
        },
        hasRecommendations() {
            return this.relatorioData?.recommendations?.length > 0;
        },
        hasKnowledgeSignals() {
            return this.relatorioData?.knowledgeSignals?.length > 0;
        },
        hasData() {
            return !!this.relatorioData?.summary;
        },
        hasError() {
            return !!this.errorMessage;
        },
        isReportDeprecated() {
            return this.normalizeReportStatus(this.reportStatus) === 'DEPRECATED';
        },
        compliantCount() {
            if (!this.hasRuleCompliance) return 0;
            return this.relatorioData.ruleCompliance.filter(rule => rule.status === 'COMPLIANT').length;
        },
        sortedRuleCompliance() {
            if (!this.hasRuleCompliance) return [];
            const weight = {
                VIOLATED: 0,
                PARTIAL: 1,
                COMPLIANT: 2
            };
            return [...this.relatorioData.ruleCompliance].sort((a, b) => {
                const left = weight[a?.status] ?? 3;
                const right = weight[b?.status] ?? 3;
                if (left !== right) return left - right;
                return String(a?.ruleId || '').localeCompare(String(b?.ruleId || ''));
            });
        }
    },
    watch: {
        currentScenarioContextKey: {
            immediate: true,
            handler(newKey, oldKey) {
                this.handleScenarioContextChange(newKey, oldKey);
            }
        }
    },
    methods: {
        onModalOpened() {
            if (!this.scenarioId) {
                this.errorMessage = this.$t('relatorio_erro_sem_id');
                return;
            }
            if (this.isReportCompatibleWithCurrentScenario(this.relatorioData)) {
                this.emitReportStatusChange();
                return;
            }
            let contextState = this.getCurrentContextLoadState();
            if (contextState === 'loaded') {
                this.setCurrentContextLoadState('idle');
                contextState = 'idle';
            }
            if (contextState === 'idle' || contextState === 'error' || contextState === 'missing') {
                this.carregarRelatorio(false, { silent: false });
            }
        },
        normalizeContextValue(value) {
            if (value === null || value === undefined) return null;
            const normalized = String(value).trim();
            return normalized.length ? normalized : null;
        },
        normalizeReportStatus(status) {
            if (status === null || status === undefined) return null;
            const normalized = String(status).trim().toUpperCase();
            return normalized.length ? normalized : null;
        },
        getCurrentContextLoadState() {
            const key = this.currentScenarioContextKey;
            if (!key) return 'idle';
            return this.contextLoadStateByKey[key] || 'idle';
        },
        setCurrentContextLoadState(state) {
            const key = this.currentScenarioContextKey;
            if (!key) return;
            this.$set(this.contextLoadStateByKey, key, state);
        },
        getReportScenarioVersion(reportData = this.relatorioData) {
            return this.normalizeContextValue(reportData?.metadata?.scenario?.version)
                || this.normalizeContextValue(this.reportScenarioVersion);
        },
        getCurrentScenarioVersionForStatus() {
            return this.normalizeContextValue(this.reportCurrentScenarioVersion)
                || this.normalizeContextValue(this.scenarioVersion);
        },
        resolveReportStatus(relatorioRow = null, parsedReport = null) {
            const statusFromBackend = this.normalizeReportStatus(relatorioRow?.STATUSRELATORIOIA);
            if (statusFromBackend) {
                return statusFromBackend;
            }

            const reportVersionFromMetadata = this.normalizeContextValue(parsedReport?.metadata?.scenario?.version);
            const reportVersionFromRow = this.normalizeContextValue(relatorioRow?.VERSAORELATORIOIA);
            const reportVersion = reportVersionFromRow || reportVersionFromMetadata;
            const currentScenarioVersion = this.normalizeContextValue(relatorioRow?.VERSAOCENARIOATUAL)
                || this.normalizeContextValue(this.scenarioVersion);

            if (!parsedReport) {
                return 'MISSING';
            }
            if (!currentScenarioVersion || !reportVersion) {
                return 'CURRENT';
            }
            return reportVersion === currentScenarioVersion ? 'CURRENT' : 'DEPRECATED';
        },
        emitReportStatusChange() {
            this.$emit('report-status-change', {
                status: this.normalizeReportStatus(this.reportStatus),
                scenarioVersion: this.getCurrentScenarioVersionForStatus(),
                reportVersion: this.normalizeContextValue(this.reportScenarioVersion)
            });
        },
        setReportStatusState(status, options = {}) {
            const {
                scenarioVersion = null,
                reportVersion = null,
                emit = true
            } = options;

            this.reportStatus = this.normalizeReportStatus(status);
            this.reportCurrentScenarioVersion = this.normalizeContextValue(scenarioVersion);
            this.reportScenarioVersion = this.normalizeContextValue(reportVersion);

            if (emit) {
                this.emitReportStatusChange();
            }
        },
        isReportCompatibleWithCurrentScenario(reportData = this.relatorioData, reportStatus = this.reportStatus) {
            if (!reportData || !this.scenarioId) return false;
            const reportScenarioId = this.normalizeContextValue(reportData?.metadata?.scenario?.scenarioId);
            const currentScenarioId = this.normalizeContextValue(this.scenarioId);
            if (!currentScenarioId) return false;
            if (reportScenarioId && reportScenarioId !== currentScenarioId) return false;

            const currentScenarioVersion = this.normalizeContextValue(this.scenarioVersion);
            if (!currentScenarioVersion) return true;

            const reportScenarioVersion = this.getReportScenarioVersion(reportData);
            if (!reportScenarioVersion) return false;
            if (reportScenarioVersion === currentScenarioVersion) return true;

            const normalizedStatus = this.normalizeReportStatus(reportStatus);
            return normalizedStatus === 'DEPRECATED';
        },
        resetReportStateForNewContext() {
            this.relatorioData = null;
            this.errorMessage = null;
            this.activeTab = 'resumo';
            this.expandedIssues = {};
            this.expandedR2Entities = {};
            this.expandedR3Groups = {};
            this.expandedR8Groups = {};
            this.expandedRules = {};
            this.setReportStatusState(null, { emit: false });
        },
        handleScenarioContextChange(newKey, oldKey) {
            if (!newKey) {
                this.resetReportStateForNewContext();
                return;
            }

            if (newKey === oldKey) return;
            this.resetReportStateForNewContext();
        },
        getDictionary(key, type, property = 'text') {
            if (!key || !type) return key || '';
            const item = DICTIONARY[type]?.[key];
            if (!item) return key;
            if (property && typeof item === 'object') {
                return item[property] || key;
            }
            return typeof item === 'string' ? item : item.text || key;
        },
        formatDate(dateString) {
            if (!dateString) return '';
            try {
                return this.normalizeDateForMenu(dateString) || dateString;
            } catch {
                return dateString;
            }
        },
        formatScenarioPeriod(period) {
            if (!period) return '-';
            const start = this.parsePeriodDate(period.startDate);
            const end = this.parsePeriodDate(period.endDate);
            if (!start) return '-';

            const capitalize = (text) => text ? text.charAt(0).toUpperCase() + text.slice(1) : text;
            const startLabel = capitalize(start.clone().locale('pt-br').format('MMMM [de] YYYY'));

            if (!end || start.isSame(end, 'month')) {
                return startLabel;
            }

            const endLabel = capitalize(end.clone().locale('pt-br').format('MMMM [de] YYYY'));
            return `${startLabel} ${this.$t('to')} ${endLabel}`;
        },
        parsePeriodDate(value) {
            if (!value) return null;
            const raw = String(value).trim();
            if (!raw) return null;

            const parsed = moment(raw, ['YYYY-MM-DD', 'DD/MM/YYYY'], true);
            if (parsed.isValid()) return parsed;

            const fallback = moment(raw);
            return fallback.isValid() ? fallback : null;
        },
        normalizeDateForMenu(dateString) {
            if (!dateString) return null;
            if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateString)) {
                return dateString;
            }
            if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
                const [year, month, day] = dateString.split('-');
                return `${day}/${month}/${year}`;
            }
            const parsed = new Date(dateString);
            if (Number.isNaN(parsed.getTime())) return null;
            return parsed.toLocaleDateString('pt-BR');
        },
        formatDateTime(dateTimeString) {
            if (!dateTimeString) return '';
            try {
                const date = new Date(dateTimeString);
                return date.toLocaleString('pt-BR');
            } catch {
                return dateTimeString;
            }
        },
        getScoreClass(score) {
            if (score >= 90) return 'excellent';
            if (score >= 70) return 'good';
            if (score >= 50) return 'regular';
            return 'poor';
        },
        resolveRuleLabel(ruleId) {
            return RULE_LABELS[ruleId] || ruleId || '-';
        },
        getIssueRule(issue, entity) {
            return entity?.rule || issue?.ruleReference || null;
        },
        shouldRenderEntity(issue, entity) {
            const ruleId = this.getIssueRule(issue, entity);
            if (ruleId !== 'R2') return true;

            const count = Number(entity?.count ?? 0);
            const hasGroups = Array.isArray(entity?.groups) && entity.groups.length > 0;
            return count > 0 || hasGroups;
        },
        getVisibleEntities(issue) {
            const entities = Array.isArray(issue?.affectedEntities) ? issue.affectedEntities : [];
            return entities.filter(entity => this.shouldRenderEntity(issue, entity));
        },
        getEntitiesCount(issue) {
            return this.getVisibleEntities(issue).length;
        },
        hasEntities(issue) {
            return this.getEntitiesCount(issue) > 0;
        },
        isR1Entity(issue, entity) {
            return this.getIssueRule(issue, entity) === 'R1';
        },
        isR2Entity(issue, entity) {
            return this.getIssueRule(issue, entity) === 'R2';
        },
        getR2EntityKey(issue, issueIndex, entity, entityIndex = 0) {
            const issueKey = this.getIssueKey(issue, issueIndex);
            const category = typeof entity?.category === 'string' && entity.category.trim().length
                ? entity.category.trim().toUpperCase()
                : `entity-${entityIndex}`;
            return `${issueKey}::${category}`;
        },
        toggleR2Entity(issue, issueIndex, entity, entityIndex = 0) {
            const issueKey = this.getIssueKey(issue, issueIndex);
            const entityKey = this.getR2EntityKey(issue, issueIndex, entity, entityIndex);
            const current = this.expandedR2Entities[issueKey] || null;
            if (current === entityKey) {
                this.$set(this.expandedR2Entities, issueKey, null);
                return;
            }
            this.$set(this.expandedR2Entities, issueKey, entityKey);
        },
        isR2EntityExpanded(issue, issueIndex, entity, entityIndex = 0) {
            const issueKey = this.getIssueKey(issue, issueIndex);
            const current = this.expandedR2Entities[issueKey] || null;
            if (!current) return false;
            return current === this.getR2EntityKey(issue, issueIndex, entity, entityIndex);
        },
        isR3Issue(issue) {
            if (issue?.ruleReference === 'R3') return true;
            if (!Array.isArray(issue?.affectedEntities)) return false;
            return issue.affectedEntities.some(entity => this.getIssueRule(issue, entity) === 'R3');
        },
        isR3Entity(issue, entity) {
            return this.getIssueRule(issue, entity) === 'R3';
        },
        getR3EntityScope(entity) {
            const normalized = String(entity?.scope || '').trim().toUpperCase();
            if (normalized === 'BY_TYPE' || normalized === 'GLOBAL_DAY') return normalized;
            return entity?.tipo ? 'BY_TYPE' : 'GLOBAL_DAY';
        },
        isR3ByTypeEntity(entity) {
            return this.getR3EntityScope(entity) === 'BY_TYPE';
        },
        getR3EntityGroups(issue) {
            const entities = this.getVisibleEntities(issue)
                .filter(entity => this.getIssueRule(issue, entity) === 'R3');
            const byType = entities.filter(entity => this.getR3EntityScope(entity) === 'BY_TYPE');
            const globalDay = entities.filter(entity => this.getR3EntityScope(entity) === 'GLOBAL_DAY');
            const sortEntities = list => [...list].sort((a, b) => {
                const dateA = this.normalizeDateForMenu(a?.date) || this.formatDate(a?.date) || '';
                const dateB = this.normalizeDateForMenu(b?.date) || this.formatDate(b?.date) || '';
                const compareDate = dateA.localeCompare(dateB);
                if (compareDate !== 0) return compareDate;
                return String(a?.tipo || '').localeCompare(String(b?.tipo || ''));
            });

            const groups = [
                {
                    groupKey: 'BY_TYPE',
                    label: this.$t('relatorio_r3_grupo_por_tipo'),
                    entities: sortEntities(byType)
                },
                {
                    groupKey: 'GLOBAL_DAY',
                    label: this.$t('relatorio_r3_grupo_global_dia'),
                    entities: sortEntities(globalDay)
                }
            ];

            return groups.filter(group => group.entities.length > 0);
        },
        hasR3GroupedEntities(issue) {
            return this.getR3EntityGroups(issue).length > 0;
        },
        getR3GroupStorageKey(issue, issueIndex, groupKey) {
            return `${this.getIssueKey(issue, issueIndex)}::${groupKey}`;
        },
        toggleR3Group(issue, issueIndex, groupKey) {
            const storageKey = this.getR3GroupStorageKey(issue, issueIndex, groupKey);
            this.$set(this.expandedR3Groups, storageKey, !this.expandedR3Groups[storageKey]);
        },
        isR3GroupExpanded(issue, issueIndex, groupKey) {
            const storageKey = this.getR3GroupStorageKey(issue, issueIndex, groupKey);
            return !!this.expandedR3Groups[storageKey];
        },
        isR8Issue(issue) {
            if (issue?.ruleReference === 'R8') return true;
            if (!Array.isArray(issue?.affectedEntities)) return false;
            return issue.affectedEntities.some(entity => this.getIssueRule(issue, entity) === 'R8');
        },
        isR8UnmetEntity(issue, entity) {
            return this.getIssueRule(issue, entity) === 'R8'
                && this.getR8EntityCategory(entity) === 'UNMET';
        },
        isR10Entity(issue, entity) {
            return this.getIssueRule(issue, entity) === 'R10';
        },
        isR9Entity(issue, entity) {
            return this.getIssueRule(issue, entity) === 'R9';
        },
        getR8EntityCategory(entity) {
            const normalized = String(entity?.category || '').trim().toUpperCase();
            if (normalized === 'UNMET' || normalized === 'UNREALIZED') return normalized;
            return String(entity?.scope || '').toUpperCase() === 'MONTH' ? 'UNREALIZED' : 'UNMET';
        },
        getR8CategoryLabel(category) {
            if (category === 'UNMET') return this.$t('relatorio_r8_categoria_unmet');
            if (category === 'UNREALIZED') return this.$t('relatorio_r8_categoria_unrealized');
            return '-';
        },
        getR8EntityGroups(issue) {
            const entities = this.getVisibleEntities(issue)
                .filter(entity => this.getIssueRule(issue, entity) === 'R8');

            const byCategory = new Map();
            entities.forEach((entity, entityIndex) => {
                const category = this.getR8EntityCategory(entity);
                const current = byCategory.get(category) || [];
                current.push({ entity, entityIndex });
                byCategory.set(category, current);
            });

            const categoryOrder = ['UNMET', 'UNREALIZED'];
            return categoryOrder
                .filter(category => byCategory.has(category))
                .map((category) => ({
                    groupKey: category,
                    label: this.getR8CategoryLabel(category),
                    entities: byCategory.get(category).map(entry => entry.entity),
                }));
        },
        hasR8GroupedEntities(issue) {
            return this.getR8EntityGroups(issue).length > 0;
        },
        getR8GroupStorageKey(issue, issueIndex, groupKey) {
            return `${this.getIssueKey(issue, issueIndex)}::R8::${groupKey}`;
        },
        toggleR8Group(issue, issueIndex, groupKey) {
            const storageKey = this.getR8GroupStorageKey(issue, issueIndex, groupKey);
            this.$set(this.expandedR8Groups, storageKey, !this.expandedR8Groups[storageKey]);
        },
        isR8GroupExpanded(issue, issueIndex, groupKey) {
            const storageKey = this.getR8GroupStorageKey(issue, issueIndex, groupKey);
            return !!this.expandedR8Groups[storageKey];
        },
        getR3EntityActions(entity) {
            const tags = this.buildR3Tags(entity);
            const allTargets = this.buildR3AllTargets(entity, tags);
            if (allTargets.length) {
                return [{
                    label: this.$t('relatorio_destacar_conflitos'),
                    highlightType: 'conflict',
                    highlightTargets: allTargets
                }];
            }
            if (entity?.date) {
                return [{
                    date: entity.date,
                    highlightType: 'conflict'
                }];
            }
            return [];
        },
        clearIssueScopedExpansionState(issueId) {
            if (!issueId) return;
            if (this.expandedR2Entities[issueId] !== undefined) {
                this.$delete(this.expandedR2Entities, issueId);
            }
            const prefix = `${issueId}::`;
            Object.keys(this.expandedR3Groups).forEach((key) => {
                if (key.startsWith(prefix)) {
                    this.$delete(this.expandedR3Groups, key);
                }
            });
            Object.keys(this.expandedR8Groups).forEach((key) => {
                if (key.startsWith(prefix)) {
                    this.$delete(this.expandedR8Groups, key);
                }
            });
        },
        toggleIssue(issueId, issue = null, issueIndex = null) {
            const current = !!this.expandedIssues[issueId];
            const next = !current;
            this.expandedIssues = {
                ...this.expandedIssues,
                [issueId]: next
            };

            if (next && issue) {
                this.clearIssueScopedExpansionState(issueId);
                this.$set(this.expandedR2Entities, issueId, null);
                return;
            }

            if (!next) {
                this.clearIssueScopedExpansionState(issueId);
            }
        },
        isIssueExpanded(issueId) {
            return !!this.expandedIssues[issueId];
        },
        toggleRule(ruleId, index) {
            const key = `${ruleId}-${index}`;
            const current = !!this.expandedRules[key];
            this.expandedRules = {
                ...this.expandedRules,
                [key]: !current
            };
        },
        isRuleExpanded(ruleId, index) {
            return !!this.expandedRules[`${ruleId}-${index}`];
        },
        getIssueKey(issue, index) {
            return issue?.issueId || `issue-${index}`;
        },
        findIssueByRule(ruleId) {
            if (!ruleId || !Array.isArray(this.relatorioData?.issues)) return null;
            const issueIndex = this.relatorioData.issues.findIndex((issue) => {
                if (issue?.ruleReference === ruleId) return true;
                if (!Array.isArray(issue?.affectedEntities)) return false;
                return issue.affectedEntities.some(entity => entity?.rule === ruleId);
            });
            if (issueIndex < 0) return null;
            return { issue: this.relatorioData.issues[issueIndex], issueIndex };
        },
        hasIssueForRule(ruleId) {
            return !!this.findIssueByRule(ruleId);
        },
        getTabsContentElement() {
            return this.$el?.querySelector('.tabs-content') || null;
        },
        scrollTabsContentTo(top = 0, behavior = 'auto') {
            const container = this.getTabsContentElement();
            if (!container) return;
            container.scrollTo({ top: Math.max(0, top), behavior });
        },
        scrollIssueIntoProblemsTab(issueKey) {
            const container = this.getTabsContentElement();
            const target = this.$el?.querySelector(`[data-issue-key="${issueKey}"]`);
            if (!container || !target) return;

            const containerRect = container.getBoundingClientRect();
            const targetRect = target.getBoundingClientRect();
            const offsetTop = targetRect.top - containerRect.top + container.scrollTop - 12;
            this.scrollTabsContentTo(offsetTop, 'smooth');
        },
        refreshModalLayout() {
            this.$nextTick(() => {
                requestAnimationFrame(() => {
                    window.dispatchEvent(new Event('resize'));
                });
            });
        },
        openIssueFromRule(ruleId) {
            const issueData = this.findIssueByRule(ruleId);
            if (!issueData) return;

            const issueKey = this.getIssueKey(issueData.issue, issueData.issueIndex);
            this.$set(this.expandedIssues, issueKey, true);
            this.$set(this.expandedR2Entities, issueKey, null);
            this.activeTab = 'problemas';

            this.$nextTick(() => {
                this.scrollTabsContentTo(0, 'auto');
                this.refreshModalLayout();
                this.$nextTick(() => {
                    this.scrollIssueIntoProblemsTab(issueKey);
                });
            });
        },
        getEntityLabel(entity) {
            if (!entity) return '-';
            if (typeof entity === 'string' || typeof entity === 'number') {
                return this.formatTokenLabel(String(entity));
            }
            const parsed = this.extractEntityCodeName(entity);
            const shouldShowCode = this.shouldShowEntityCode(entity);
            if (shouldShowCode && parsed.code !== '-' && parsed.name !== '-') return `${parsed.code} | ${parsed.name}`;
            if (parsed.name !== '-') return parsed.name;
            if (shouldShowCode && parsed.code !== '-') return parsed.code;
            return '-';
        },
        formatCriterion(value) {
            const map = {
                ZERO_USAGE: this.$t('relatorio_criterio_zero_usage'),
                MAX_MONTH: this.$t('relatorio_criterio_max_month'),
                MIN_MONTH: this.$t('relatorio_criterio_min_month'),
                MAX_WEEK: this.$t('relatorio_criterio_max_week')
            };
            return map[value] || value || '-';
        },
        getIssueDescription(issue) {
            const rawDescription = issue?.description || '';
            if (!rawDescription) return '-';

            const hasR1ZeroUsage = Array.isArray(issue?.affectedEntities)
                && issue.affectedEntities.some((entity) => {
                    const ruleId = this.getIssueRule(issue, entity);
                    return ruleId === 'R1' && String(entity?.criterion || '').toUpperCase() === 'ZERO_USAGE';
                });

            if (!hasR1ZeroUsage) return rawDescription;

            return String(rawDescription)
                .replace(/foi utilizado com zero uso/gi, 'não foi utilizado')
                .replace(/utilizado com zero uso/gi, 'sem utilização');
        },
        formatScope(scope, week) {
            if (!scope) return '-';
            if (scope === 'WEEK') return week ? `${this.$t('week')}: ${week}` : this.$t('week');
            return this.$t('month');
        },
        formatR5ContextMode(mode) {
            if (mode === 'DAY_TYPE') return this.$t('relatorio_contexto_por_tipo');
            if (mode === 'DAY_GLOBAL') return this.$t('relatorio_contexto_global_dia');
            return '-';
        },
        buildR5ContextTargets(context) {
            const reasonLabel = this.$t('relatorio_r5_highlight_prato_alta_complexidade');
            return this.buildTargetsFromIssueTargets(
                context?.highComplexityTargets,
                null,
                'usage',
                {
                    reasonLabel,
                    reasonKey: `R5:${context?.date || 'unknown'}:${context?.mode || 'unknown'}:${context?.tipo || 'global'}`,
                    origin: 'action'
                }
            );
        },
        formatPercent(value) {
            const numeric = Number(value);
            if (!Number.isFinite(numeric)) return '-';
            return `${(numeric * 100).toFixed(1)}%`;
        },
        formatCategory(category) {
            if (!category) return '-';
            const normalized = String(category).toUpperCase();
            const map = {
                ABOVE_MAX: 'relatorio_categoria_above_max',
                NON_USED: 'relatorio_categoria_non_used',
                BELOW_MIN: 'relatorio_categoria_below_min'
            };
            const key = map[normalized];
            return key ? this.$t(key) : normalized;
        },
        formatR9ConflictType(conflictType) {
            if (!conflictType) return '-';
            const normalized = String(conflictType).toUpperCase();
            const map = {
                PRATO_PRATO: 'relatorio_r9_conflict_type_prato_prato',
                PRATO_GRUPO: 'relatorio_r9_conflict_type_prato_grupo',
                GRUPO_PRATO: 'relatorio_r9_conflict_type_grupo_prato',
                GRUPO_GRUPO: 'relatorio_r9_conflict_type_grupo_grupo'
            };
            const key = map[normalized];
            return key ? this.$t(key) : normalized;
        },
        formatUsage(usage) {
            if (!usage) return '-';
            const parsed = this.parseUsage(usage);
            const parts = [
                `${this.$t('relatorio_utilizado')}: ${parsed.used}`,
                `${this.$t('relatorio_minimo')}: ${parsed.min}`,
                `${this.$t('relatorio_maximo')}: ${parsed.max}`
            ];
            if (parsed.delta !== null) {
                parts.push(`${this.$t('relatorio_diferenca')}: ${parsed.delta}`);
            }
            return parts.join(' | ');
        },
        parseUsage(usage) {
            if (!usage) {
                return { used: 0, min: '-', max: '-', delta: null };
            }
            return {
                used: usage.used ?? 0,
                min: usage.min ?? '-',
                max: usage.max ?? '-',
                delta: usage.delta ?? null
            };
        },
        buildUsageRow(label, usage) {
            return {
                label,
                type: 'usage',
                usage: this.parseUsage(usage)
            };
        },
        buildEntityRow(label, entity, options = {}) {
            const parsed = this.extractEntityCodeName(entity);
            const shouldShowCode = this.shouldShowEntityCode(entity);
            return {
                label,
                type: 'entity',
                code: shouldShowCode && parsed.code !== '-' ? parsed.code : null,
                name: parsed.name,
                nameTitle: parsed.name !== '-' ? parsed.name : null,
                codeLabel: options.codeLabel !== false,
                singleLine: !!options.singleLine
            };
        },
        formatColumnDisplay(column) {
            if (!column) return '-';

            const rawLabel = String(column.name || column.label || column.id || '').trim();
            if (!rawLabel) return '-';

            const suffixMatch = rawLabel.match(/(\d+)\s*$/);
            if (suffixMatch) return suffixMatch[1];

            const normalized = rawLabel.replace(/^coluna\s*:?/i, '').trim();
            if (normalized) return normalized;

            const rawId = column.id !== undefined && column.id !== null ? String(column.id).trim() : '';
            return rawId || rawLabel;
        },
        getR10ColumnContext(entity) {
            if (!entity || typeof entity !== 'object') return null;

            if (entity.columnContext && typeof entity.columnContext === 'object') {
                return entity.columnContext;
            }

            if (entity.column && typeof entity.column === 'object') {
                return entity.column;
            }

            return null;
        },
        getR10DishTypeName(entity) {
            const context = this.getR10ColumnContext(entity);
            if (!context || typeof context.dishTypeName !== 'string') return null;
            const normalized = context.dishTypeName.trim();
            return normalized || null;
        },
        getR10DishGroups(entity) {
            const context = this.getR10ColumnContext(entity);
            if (!context || !Array.isArray(context.dishGroups)) return [];

            return context.dishGroups
                .map((group) => this.formatTokenLabel(String(group || '').trim()))
                .filter((group) => group && group !== '-');
        },
        shouldShowEntityCode(entity) {
            if (!entity) return false;

            const normalize = (value) => String(value || '').trim();

            if (typeof entity === 'string' || typeof entity === 'number') {
                const raw = normalize(entity).toLowerCase();
                return raw.startsWith('prato:');
            }

            const entityType = normalize(entity.entityType || entity.type || entity.kind).toUpperCase();
            if (entityType) {
                return entityType === 'PRATO' || entityType === 'PLATE';
            }

            const label = normalize(entity.label).toLowerCase();
            if (label.startsWith('prato:')) return true;

            const id = normalize(entity.id);
            return /^P\d+$/i.test(id);
        },
        getR8RequiredEntityLabel(entity) {
            const required = entity?.requiredItem
                || (Array.isArray(entity?.missingItems) && entity.missingItems.length === 1 ? entity.missingItems[0] : null);
            if (!required) {
                return this.$t('relatorio_entidade_item_obrigatorio');
            }
            const entityType = String(required?.entityType || '').trim().toUpperCase();
            if (entityType === 'PRATO' || entityType === 'PLATE') {
                return this.$t('relatorio_entidade_prato_obrigatorio');
            }
            if (entityType === 'GRUPO' || entityType === 'GROUP') {
                return this.$t('relatorio_entidade_grupo_obrigatorio');
            }
            if (this.isPlateEntity(required)) {
                return this.$t('relatorio_entidade_prato_obrigatorio');
            }
            return this.$t('relatorio_entidade_item_obrigatorio');
        },
        formatTokenLabel(value) {
            if (!value) return '-';
            const parsed = String(value);
            if (parsed.includes('|')) {
                return parsed.split('|').slice(1).join('|').trim();
            }
            return parsed;
        },
        extractEntityCodeName(entity) {
            if (!entity) return { code: '-', name: '-' };

            if (typeof entity === 'string' || typeof entity === 'number') {
                const labelOnly = String(entity);
                if (labelOnly.includes('|')) {
                    const left = labelOnly.split('|')[0];
                    const code = left.includes(':') ? left.split(':').pop() : left;
                    const name = labelOnly.split('|').slice(1).join('|').trim();
                    return { code: code || '-', name: name || '-' };
                }
                return { code: '-', name: labelOnly };
            }

            const rawId = entity.id !== undefined && entity.id !== null ? String(entity.id) : '';
            const rawName = entity.name ? String(entity.name) : '';
            const label = entity.label ? String(entity.label) : '';

            let code = rawId;
            if (code.includes(':')) {
                code = code.split(':').pop();
            }
            if (!code && label && label.includes('|')) {
                const left = label.split('|')[0];
                code = left.includes(':') ? left.split(':').pop() : left;
            }

            let name = rawName;
            if (!name && label && label.includes('|')) {
                name = label.split('|').slice(1).join('|').trim();
            }
            if (!name && label && label !== '-') {
                name = label;
            }

            return {
                code: code || '-',
                name: name || '-'
            };
        },
        formatBoolean(value) {
            if (value === true) return this.$t('yes');
            if (value === false) return this.$t('no');
            return '-';
        },
        normalizeSequencial(value) {
            if (value === null || value === undefined) return null;
            const normalized = String(value).trim();
            return normalized.length ? normalized : null;
        },
        normalizePlateId(value) {
            if (value === null || value === undefined) return null;
            const normalized = String(value).trim();
            return normalized.length ? normalized : null;
        },
        normalizeHighlightType(value) {
            if (!value) return 'conflict';
            const normalized = String(value).trim().toLowerCase();
            if (normalized === 'usage' || normalized === 'candidate' || normalized === 'conflict') {
                return normalized;
            }
            return 'conflict';
        },
        getActionHighlightType(action) {
            if (!action || typeof action !== 'object') return 'conflict';
            if (action.highlightType) {
                return this.normalizeHighlightType(action.highlightType);
            }
            if (Array.isArray(action.highlightTargets) && action.highlightTargets.length > 0) {
                return this.normalizeHighlightType(action.highlightTargets[0]?.highlightType || 'conflict');
            }
            return 'conflict';
        },
        getActionButtonClass(action) {
            const type = this.getActionHighlightType(action);
            return {
                'navigate-btn-usage': type === 'usage',
                'navigate-btn-candidate': type === 'candidate',
                'navigate-btn-conflict': type === 'conflict'
            };
        },
        getActionLabel(action, fallbackKey = 'relatorio_ir_para_cardapio') {
            if (action?.label) return action.label;
            return this.$t(fallbackKey);
        },
        normalizeReasonLabel(reasonLabel) {
            if (typeof reasonLabel !== 'string') return null;
            const normalized = reasonLabel.trim();
            return normalized.length ? normalized : null;
        },
        normalizeReasonKey(reasonKey) {
            if (typeof reasonKey !== 'string') return null;
            const normalized = reasonKey.trim();
            return normalized.length ? normalized : null;
        },
        buildHighlightTarget(date, sequencial, plateId, highlightType = 'conflict', metadata = null) {
            const normalizedDate = this.normalizeDateForMenu(date);
            if (!normalizedDate) return null;
            const normalizedReasonLabel = this.normalizeReasonLabel(metadata?.reasonLabel);
            const normalizedReasonKey = this.normalizeReasonKey(metadata?.reasonKey);
            const normalizedOrigin = metadata?.origin || null;
            return {
                date: normalizedDate,
                sequencial: this.normalizeSequencial(sequencial),
                plateId: this.normalizePlateId(plateId),
                highlightType: this.normalizeHighlightType(highlightType),
                reasonLabel: normalizedReasonLabel,
                reasonKey: normalizedReasonKey,
                reasonLabels: normalizedReasonLabel ? [normalizedReasonLabel] : [],
                origin: normalizedOrigin
            };
        },
        normalizeHighlightTarget(target, fallbackType = 'conflict') {
            if (!target) return null;
            return this.buildHighlightTarget(
                target.date,
                target.sequencial,
                target.plateId,
                target.highlightType || fallbackType,
                {
                    reasonLabel: target.reasonLabel,
                    reasonKey: target.reasonKey,
                    origin: target.origin
                }
            );
        },
        dedupeTargets(targets = []) {
            const uniq = new Map();
            targets.forEach((target) => {
                const normalized = this.normalizeHighlightTarget(target);
                if (!normalized) return;
                const key = [
                    normalized.date,
                    normalized.sequencial || '-',
                    normalized.plateId || '-',
                    normalized.highlightType || 'conflict'
                ].join('::');
                if (!uniq.has(key)) {
                    uniq.set(key, normalized);
                    return;
                }

                const existing = uniq.get(key);
                const labels = new Set([...(existing.reasonLabels || [])]);
                if (normalized.reasonLabel) labels.add(normalized.reasonLabel);

                const mergedLabels = Array.from(labels);
                uniq.set(key, {
                    ...existing,
                    reasonLabel: existing.reasonLabel || normalized.reasonLabel || null,
                    reasonKey: existing.reasonKey || normalized.reasonKey || null,
                    reasonLabels: mergedLabels,
                    origin: existing.origin || normalized.origin || null
                });
            });
            return Array.from(uniq.values());
        },
        buildTargetsFromIssueTargets(targets, fallbackPlateId = null, highlightType = 'conflict', metadata = null) {
            if (!Array.isArray(targets)) return [];
            const normalizedTargets = targets.map((target) => this.buildHighlightTarget(
                target?.date,
                target?.sequencial,
                target?.plateId ?? fallbackPlateId,
                highlightType,
                metadata
            ));
            return this.dedupeTargets(normalizedTargets);
        },
        getR8TargetRequiredName(target) {
            const rawReason = this.normalizeReasonLabel(target?.reason);
            if (!rawReason) return null;
            if (['AVAILABLE_REQUIRED_IN_COLUMN', 'AVAILABLE_PIVOT_IN_COLUMN'].includes(rawReason)) {
                return null;
            }
            if (rawReason.includes('|')) {
                const [, rawName] = rawReason.split('|');
                const normalizedName = rawName?.trim();
                if (normalizedName) return normalizedName;
            }
            return rawReason;
        },
        buildR1UsageTargets(entity) {
            const occurrences = Array.isArray(entity?.occurrences) ? entity.occurrences : [];
            const plateId = entity?.plate?.id || null;
            const plateName = this.extractEntityCodeName(entity?.plate).name || this.$t('relatorio_entidade_prato');
            const reasonLabel = this.$t('relatorio_highlight_utilizacao_de', { PARAM: plateName });
            const targets = occurrences.map((occ) => this.buildHighlightTarget(
                occ?.date,
                occ?.sequencial,
                plateId,
                'usage',
                {
                    reasonLabel,
                    reasonKey: `R1:usage:${plateId || plateName}`,
                    origin: 'action'
                }
            ));
            return this.dedupeTargets(targets);
        },
        buildR1CandidateTargets(entity) {
            const plateId = entity?.plate?.id || null;
            const plateName = this.extractEntityCodeName(entity?.plate).name || this.$t('relatorio_entidade_prato');
            return this.buildTargetsFromIssueTargets(
                entity?.candidateTargets,
                plateId,
                'candidate',
                {
                    reasonLabel: this.$t('relatorio_highlight_oportunidade_para_adicionar', { PARAM: plateName }),
                    reasonKey: `R1:candidate:${plateId || plateName}`,
                    origin: 'action'
                }
            );
        },
        buildR2UsageTargets(groupEntry) {
            const groupInfo = this.extractEntityCodeName(groupEntry?.group);
            const groupName = groupEntry?.groupName || groupInfo.name || this.$t('group_of_dishes');
            return this.buildTargetsFromIssueTargets(
                groupEntry?.occurrences,
                null,
                'usage',
                {
                    reasonLabel: this.$t('relatorio_highlight_utilizacao_de', { PARAM: groupName }),
                    reasonKey: `R2:usage:${groupEntry?.groupCode || groupInfo.code || groupName}`,
                    origin: 'action'
                }
            );
        },
        buildR2CandidateTargets(groupEntry) {
            const groupInfo = this.extractEntityCodeName(groupEntry?.group);
            const groupName = groupEntry?.groupName || groupInfo.name || this.$t('group_of_dishes');
            const metadata = {
                reasonLabel: this.$t('relatorio_highlight_oportunidade_para_adicionar', { PARAM: groupName }),
                reasonKey: `R2:candidate:${groupEntry?.groupCode || groupInfo.code || groupName}`,
                origin: 'action'
            };
            const candidateCells = Array.isArray(groupEntry?.candidateCells) ? groupEntry.candidateCells : [];
            if (candidateCells.length) {
                const cellTargets = candidateCells.map((cell) => this.buildHighlightTarget(
                    cell?.date,
                    cell?.sequencial,
                    null,
                    'candidate',
                    metadata
                ));
                return this.dedupeTargets(cellTargets);
            }

            const legacyTargets = this.buildTargetsFromIssueTargets(
                groupEntry?.candidateTargets,
                null,
                'candidate',
                metadata
            );
            const byCell = new Map();
            legacyTargets.forEach((target) => {
                const key = [target.date, target.sequencial || '-'].join('::');
                if (!byCell.has(key)) {
                    byCell.set(key, {
                        ...target,
                        plateId: null
                    });
                }
            });
            return Array.from(byCell.values());
        },
        buildR4Targets(date, plates, fallbackSequentials, metadata = null) {
            const result = [];
            const safePlates = Array.isArray(plates) ? plates : [];
            const safeSequentials = Array.isArray(fallbackSequentials) ? fallbackSequentials : [];

            safePlates.forEach((plate, index) => {
                const sequencial = plate?.sequencial ?? safeSequentials[index] ?? null;
                result.push(this.buildHighlightTarget(date, sequencial, plate?.idPrato, 'conflict', metadata));
            });

            if (!safePlates.length && safeSequentials.length) {
                safeSequentials.forEach((sequencial) => {
                    result.push(this.buildHighlightTarget(date, sequencial, null, 'conflict', metadata));
                });
            }

            if (!result.length) {
                result.push(this.buildHighlightTarget(date, null, null, 'conflict', metadata));
            }

            return this.dedupeTargets(result);
        },
        buildR8CandidateTargets(entity, mode = 'required') {
            const pivotName = this.extractEntityCodeName(entity?.pivot).name || this.$t('relatorio_entidade_pivo');
            const missingItems = Array.isArray(entity?.missingItems) ? entity.missingItems : [];
            const requiredRefs = mode === 'pivot'
                ? []
                : (missingItems.length
                    ? missingItems
                    : [entity?.requiredItem || null].filter(Boolean));

            if (mode === 'required' && requiredRefs.length) {
                const targets = Array.isArray(entity?.candidateTargets) ? entity.candidateTargets : [];
                const fallbackRequiredNames = requiredRefs.map((requiredRef) =>
                    this.extractEntityCodeName(requiredRef).name || this.$t('relatorio_entidade_item_obrigatorio')
                );
                const expandedTargets = targets.flatMap((target) => {
                    const targetRequiredName = this.getR8TargetRequiredName(target);
                    const candidateNames = targetRequiredName ? [targetRequiredName] : fallbackRequiredNames;
                    return candidateNames.map((requiredName) => this.buildHighlightTarget(
                        target?.date,
                        target?.sequencial,
                        target?.plateId ?? null,
                        'candidate',
                        {
                            reasonLabel: this.$t('relatorio_r8_oportunidade_para', { PARAM: requiredName }),
                            reasonKey: `R8:${mode}:candidate:${requiredName}`,
                            origin: 'action'
                        }
                    ));
                });
                return this.dedupeTargets(expandedTargets);
            }

            const reasonLabel = this.$t('relatorio_r8_oportunidade_para_adicionar', { PARAM: pivotName });
            return this.buildTargetsFromIssueTargets(
                entity?.candidateTargets,
                null,
                'candidate',
                {
                    reasonLabel,
                    reasonKey: `R8:${mode}:candidate:${entity?.pivot?.id || pivotName}`,
                    origin: 'action'
                }
            );
        },
        getR9ConflictTargetName(target) {
            const rawReason = this.normalizeReasonLabel(target?.reason);
            if (!rawReason) return null;
            const parsed = this.extractEntityCodeName(rawReason);
            if (parsed.name && parsed.name !== '-') return parsed.name;
            const fallback = this.formatTokenLabel(rawReason);
            return fallback !== '-' ? fallback : null;
        },
        isSameR9Entity(target, entityRef) {
            if (!target || !entityRef) return false;

            const targetPlateId = this.normalizePlateId(target?.plateId);
            const entityId = this.normalizePlateId(entityRef?.id);
            const entityType = String(entityRef?.entityType || '').trim().toUpperCase();

            if (entityType === 'PRATO' && targetPlateId && entityId && targetPlateId === entityId) {
                return true;
            }

            const targetReason = this.normalizeReasonLabel(target?.reason);
            if (!targetReason) return false;

            const targetParsed = this.extractEntityCodeName(targetReason);
            const entityParsed = this.extractEntityCodeName(entityRef);

            if (entityId && targetParsed.code !== '-' && targetParsed.code === entityId) {
                return true;
            }

            const targetName = (targetParsed.name || '').trim().toUpperCase();
            const entityName = (entityParsed.name || '').trim().toUpperCase();
            if (targetName && entityName && targetName === entityName) {
                return true;
            }

            return false;
        },
        getR9ConflictCounterpartName(entity, target) {
            const leftName = this.extractEntityCodeName(entity?.left).name || this.$t('relatorio_entidade_lado_esquerdo');
            const rightName = this.extractEntityCodeName(entity?.right).name || this.$t('relatorio_entidade_lado_direito');

            if (this.isSameR9Entity(target, entity?.left)) return rightName;
            if (this.isSameR9Entity(target, entity?.right)) return leftName;

            return this.getR9ConflictTargetName(target) || rightName || leftName;
        },
        buildR9ConflictTargets(entity) {
            const targets = Array.isArray(entity?.conflictTargets) ? entity.conflictTargets : [];
            if (!targets.length) return [];

            const normalizedTargets = targets.map((target, index) => {
                const conflictName = this.getR9ConflictCounterpartName(entity, target)
                    || this.$t('relatorio_destacar_conflito');
                return this.buildHighlightTarget(
                    target?.date,
                    target?.sequencial,
                    target?.plateId,
                    'conflict',
                    {
                        reasonLabel: this.$t('relatorio_r9_conflito_com', { PARAM: conflictName }),
                        reasonKey: `R9:conflict:${target?.reason || target?.sequencial || index}`,
                        origin: 'action'
                    }
                );
            });

            return this.dedupeTargets(normalizedTargets);
        },
        getTagLabel(tag) {
            if (tag && typeof tag === 'object' && typeof tag.label === 'string') {
                return tag.label;
            }
            return String(tag ?? '-');
        },
        isActionableTag(tag) {
            if (!tag || typeof tag !== 'object') return false;
            const hasTargets = Array.isArray(tag.highlightTargets) && tag.highlightTargets.length > 0;
            const hasAction = !!tag.action;
            return hasTargets || hasAction;
        },
        handleTagAction(tag, issue, entity) {
            if (!tag || typeof tag !== 'object') return;
            if (Array.isArray(tag.highlightTargets) && tag.highlightTargets.length > 0) {
                const ruleId = this.getIssueRule(issue, entity);
                const emitted = this.emitHighlightTargets(tag.highlightTargets, ruleId, 'issue');
                if (emitted) return;
            }
            if (tag.action) {
                this.handleEntityAction(tag.action, issue, entity);
            }
        },
        getR3RepetitionRefsByToken(groupRefs, token) {
            if (!groupRefs || typeof groupRefs !== 'object') return [];
            const direct = Array.isArray(groupRefs[token]) ? groupRefs[token] : [];
            if (direct.length) return direct;

            const normalizedToken = this.formatTokenLabel(token);
            const matchedKey = Object.keys(groupRefs).find(
                key => this.formatTokenLabel(key) === normalizedToken
            );
            if (!matchedKey) return [];

            return Array.isArray(groupRefs[matchedKey]) ? groupRefs[matchedKey] : [];
        },
        buildTargetsFromRepetitionRefs(refs, fallbackDate, highlightType = 'conflict', metadata = null) {
            if (!Array.isArray(refs)) return [];
            const targets = refs.map((ref) => this.buildHighlightTarget(
                ref?.date || fallbackDate,
                ref?.sequencial,
                ref?.plateId ?? ref?.idPrato,
                highlightType,
                metadata
            ));
            return this.dedupeTargets(targets);
        },
        buildR3Tags(entity) {
            const tags = [];
            const repetitionRefs = entity?.repetitionRefs || {};
            const fallbackAction = entity?.date ? { date: entity.date } : null;

            const appendTag = (label, refs) => {
                const highlightTargets = this.buildTargetsFromRepetitionRefs(
                    refs,
                    entity?.date,
                    'conflict',
                    {
                        reasonLabel: label,
                        reasonKey: label,
                        origin: 'tag'
                    }
                );
                tags.push({
                    label,
                    highlightTargets,
                    action: highlightTargets.length ? null : fallbackAction
                });
            };

            (entity?.repetitions?.cores || []).forEach((color) => {
                const refs = this.getR3RepetitionRefsByToken(repetitionRefs?.cores, color);
                appendTag(this.$t('cor_repetida', { PARAM: color }), refs);
            });

            (entity?.repetitions?.proteinas || []).forEach((protein) => {
                const refs = this.getR3RepetitionRefsByToken(repetitionRefs?.proteinas, protein);
                appendTag(
                    this.$t('proteina_repetida', { PARAM: this.formatTokenLabel(protein) }),
                    refs
                );
            });

            (entity?.repetitions?.modosPreparo || []).forEach((prep) => {
                const refs = this.getR3RepetitionRefsByToken(repetitionRefs?.modosPreparo, prep);
                appendTag(
                    this.$t('modopreparo_repetido', { PARAM: this.formatTokenLabel(prep) }),
                    refs
                );
            });

            (entity?.repetitions?.ingredientes || []).forEach((ingredient) => {
                const refs = this.getR3RepetitionRefsByToken(repetitionRefs?.ingredientes, ingredient);
                appendTag(
                    this.$t('ingrediente_repetido', { PARAM: this.formatTokenLabel(ingredient) }),
                    refs
                );
            });

            return tags;
        },
        buildR3AllTargets(entity, preparedTags = null) {
            const tags = Array.isArray(preparedTags) ? preparedTags : this.buildR3Tags(entity);
            const allTargets = tags
                .filter(tag => Array.isArray(tag?.highlightTargets))
                .flatMap(tag => tag.highlightTargets);

            const targets = this.dedupeTargets(allTargets);
            if (targets.length) return targets;

            if (entity?.date) {
                const fallback = this.buildHighlightTarget(
                    entity.date,
                    null,
                    null,
                    'conflict',
                    {
                        reasonLabel: this.$t('relatorio_destacar_conflitos'),
                        reasonKey: 'r3-fallback-conflict',
                        origin: 'action'
                    }
                );
                return fallback ? [fallback] : [];
            }

            return [];
        },
        clearMenuHighlights() {
            this.$emit('clear-highlights-request');
        },
        highlightSolverCells() {
          if (!this.dataCatalog?.tabela) return;
          const targets = [];
          for (const dia of this.dataCatalog.tabela) {
            for (const coluna of (dia.colunas || [])) {
              if (coluna._meta && coluna._meta.id_origem === 'solver') {
                const target = this.buildHighlightTarget(
                  dia.data,
                  coluna.id_coluna,
                  coluna.id_prato,
                  'candidate'
                );
                if (target) targets.push(target);
              } else if(coluna._meta && coluna._meta.id_origem === 'solver_IA'){
                const target = this.buildHighlightTarget(
                  dia.data,
                  coluna.id_coluna,
                  coluna.id_prato,
                  'usage'
                );
                if (target) targets.push(target);
              }
            }
          }
          if (targets.length > 0) {
              this.emitHighlightTargets(targets, null, 'solver');
          }
        },
        emitHighlightTargets(targets, ruleId, source = 'issue', options = {}) {
            const normalizedTargets = this.dedupeTargets(targets);
            if (!normalizedTargets.length) return false;

            const normalizedFocusTarget = this.normalizeHighlightTarget(options?.focusTarget)
                || normalizedTargets.find(item => item.sequencial || item.plateId)
                || normalizedTargets[0];
            const normalizedFocusSequence = Array.isArray(options?.focusSequence)
                ? this.dedupeTargets(options.focusSequence)
                : [];
            const focusSequenceDelayMs = Number.isFinite(Number(options?.focusSequenceDelayMs))
                && Number(options.focusSequenceDelayMs) >= 0
                ? Number(options.focusSequenceDelayMs)
                : 1000;

            const payload = {
                targets: normalizedTargets,
                focusTarget: normalizedFocusTarget,
                ruleId: ruleId || null,
                source
            };
            if (normalizedFocusSequence.length > 1) {
                payload.focusSequence = normalizedFocusSequence;
                payload.focusSequenceDelayMs = focusSequenceDelayMs;
            }
            this.$emit('highlight-request', payload);

            if (this.autoCloseOnNavigate) {
                this.fecharModal();
            }

            return true;
        },
        handleLineAction(line, issue, entity) {
            const action = line?.action;
            if (!action) return;
            const ruleId = this.getIssueRule(issue, entity);
            if (Array.isArray(action.highlightTargets) && action.highlightTargets.length) {
                const emitted = this.emitHighlightTargets(action.highlightTargets, ruleId, 'issue', {
                    focusTarget: action.focusTarget || action,
                    focusSequence: action.focusSequence,
                    focusSequenceDelayMs: action.focusSequenceDelayMs
                });
                if (emitted) return;
            }
            const emitted = this.emitHighlightTargets([action], ruleId, 'issue');
            if (emitted) return;
            this.emitNavigateFromEntity(action.date, action.sequencial, action.plateId, ruleId, 'issue');
        },
        handleEntityAction(action, issue, entity) {
            if (!action) return;
            const ruleId = this.getIssueRule(issue, entity);
            if (Array.isArray(action.highlightTargets) && action.highlightTargets.length) {
                const emitted = this.emitHighlightTargets(action.highlightTargets, ruleId, 'issue', {
                    focusTarget: action.focusTarget || action,
                    focusSequence: action.focusSequence,
                    focusSequenceDelayMs: action.focusSequenceDelayMs
                });
                if (emitted) return;
            }
            this.emitNavigateFromEntity(action.date, action.sequencial, action.plateId, ruleId, 'issue');
        },
        stringifyEntity(entity) {
            try {
                return JSON.stringify(entity, null, 2);
            } catch {
                return String(entity);
            }
        },
        getEntityView(issue, entity) {
            const ruleId = this.getIssueRule(issue, entity);
            const view = {
                ruleId,
                rows: [],
                tags: [],
                lines: [],
                actions: [],
                fallback: false
            };

            switch (ruleId) {
                case 'R1':
                    view.rows = [
                        this.buildEntityRow(this.$t('relatorio_entidade_prato'), entity.plate, {
                            singleLine: true
                        }),
                        {
                            label: this.$t('relatorio_entidade_criterio'),
                            value: this.formatCriterion(entity.criterion),
                            valueTitle: this.formatCriterion(entity.criterion),
                            singleLine: true
                        },
                        this.buildUsageRow(this.$t('relatorio_entidade_uso'), entity.usage)
                    ];
                    view.lines = (entity.occurrences || []).map(occ => ({
                        type: 'occurrence',
                        date: this.formatDate(occ.date),
                        sequencial: occ.sequencial || '-',
                        action: occ.date ? {
                            date: occ.date,
                            sequencial: occ.sequencial,
                            plateId: entity.plate?.id || null,
                            highlightType: 'usage'
                        } : null
                    }));
                    if (['MAX_MONTH', 'MAX_WEEK'].includes(entity.criterion)) {
                        const usageTargets = this.buildR1UsageTargets(entity);
                        if (usageTargets.length) {
                            view.actions.push({
                                label: this.$t('relatorio_destacar_utilizacoes'),
                                highlightType: 'usage',
                                highlightTargets: usageTargets
                            });
                        }
                    }
                    if (['MIN_MONTH', 'ZERO_USAGE'].includes(entity.criterion)) {
                        const candidateTargets = this.buildR1CandidateTargets(entity);
                        if (candidateTargets.length) {
                            view.actions.push({
                                label: this.$t('relatorio_destacar_oportunidades'),
                                highlightType: 'candidate',
                                highlightTargets: candidateTargets
                            });
                        }
                    }
                    break;
                case 'R2':
                    view.rows = [
                        { label: this.$t('relatorio_entidade_categoria'), value: this.formatCategory(entity.category) },
                        { label: this.$t('relatorio_entidade_ocorrencias'), value: entity.count || 0 }
                    ];
                    {
                        const rawGroups = Array.isArray(entity.groups) ? entity.groups : [];
                        const preparedGroups = rawGroups.map((groupEntry, groupIndex) => {
                            const usageTargets = this.buildR2UsageTargets(groupEntry);
                            const candidateTargets = this.buildR2CandidateTargets(groupEntry);
                            return {
                                groupEntry,
                                groupIndex,
                                usageTargets,
                                candidateTargets
                            };
                        });

                        if (entity.category === 'NON_USED') {
                            preparedGroups.sort((left, right) => {
                                const leftHasCandidate = left.candidateTargets.length > 0 ? 1 : 0;
                                const rightHasCandidate = right.candidateTargets.length > 0 ? 1 : 0;
                                if (leftHasCandidate !== rightHasCandidate) {
                                    return rightHasCandidate - leftHasCandidate;
                                }
                                return left.groupIndex - right.groupIndex;
                            });
                        }

                        view.lines = preparedGroups.map((prepared) => {
                            const groupEntry = prepared.groupEntry;
                            const groupInfo = this.extractEntityCodeName(groupEntry.group);
                            const groupName = groupEntry.groupName || groupInfo.name || '-';
                            const groupCode = groupEntry.groupCode || groupEntry.group?.id || null;
                            return {
                                type: 'group-usage',
                                groupKey: groupCode || `group-${prepared.groupIndex}`,
                                name: groupName,
                                scope: groupEntry.periodLabel || groupEntry.scopeLabel || this.formatScope(groupEntry.scope, groupEntry.week),
                                used: groupEntry.usage?.used ?? 0,
                                min: groupEntry.usage?.min ?? '-',
                                max: groupEntry.usage?.max ?? '-',
                                delta: groupEntry.usage?.delta ?? null,
                                actions: (() => {
                                    const actions = [];
                                    if (prepared.usageTargets.length) {
                                        actions.push({
                                            label: this.$t('relatorio_destacar_utilizacoes'),
                                            highlightType: 'usage',
                                            highlightTargets: prepared.usageTargets
                                        });
                                    }
                                    if (['NON_USED', 'BELOW_MIN'].includes(entity.category) && prepared.candidateTargets.length) {
                                        actions.push({
                                            label: this.$t('relatorio_destacar_oportunidades'),
                                            highlightType: 'candidate',
                                            highlightTargets: prepared.candidateTargets
                                        });
                                    }
                                    return actions;
                                })()
                            };
                        });
                    }
                    break;
                case 'R3':
                    if (this.isR3ByTypeEntity(entity)) {
                        view.rows = [
                            {
                                label: this.$t('relatorio_entidade_tipo'),
                                value: entity.tipo || '-',
                                valueTitle: entity.tipo || '-',
                                singleLine: true
                            },
                            {
                                label: this.$t('date'),
                                value: this.formatDate(entity.date),
                                valueTitle: this.formatDate(entity.date),
                                singleLine: true
                            }
                        ];
                    } else {
                        view.rows = [
                            {
                                label: this.$t('date'),
                                value: this.formatDate(entity.date),
                                valueTitle: this.formatDate(entity.date),
                                singleLine: true
                            }
                        ];
                    }
                    view.tags = this.buildR3Tags(entity);
                    {
                        const allTargets = this.buildR3AllTargets(entity, view.tags);
                        if (allTargets.length) {
                            view.actions.push({
                                label: this.$t('relatorio_destacar_conflitos'),
                                highlightType: 'conflict',
                                highlightTargets: allTargets
                            });
                        } else if (entity.date) {
                            view.actions.push({
                                date: entity.date,
                                highlightType: 'conflict'
                            });
                        }
                    }
                    break;
                case 'R4':
                    {
                        const ingredientName = this.extractEntityCodeName(entity?.ingredient).name || this.getEntityLabel(entity.ingredient);
                        const previousReasonLabel = this.$t('relatorio_r4_reason_previous_day', { PARAM: ingredientName });
                        const currentReasonLabel = this.$t('relatorio_r4_reason_consecutive_day', { PARAM: ingredientName });
                        const previousTargets = entity.previousDate
                            ? this.buildR4Targets(
                                entity.previousDate,
                                entity.previousPlates,
                                entity.previousSequentials,
                                {
                                    reasonLabel: previousReasonLabel,
                                    reasonKey: `R4:${entity.previousDate}:previous`,
                                    origin: 'action'
                                }
                            )
                            : [];
                        const currentTargets = entity.date
                            ? this.buildR4Targets(
                                entity.date,
                                entity.currentPlates,
                                entity.currentSequentials,
                                {
                                    reasonLabel: currentReasonLabel,
                                    reasonKey: `R4:${entity.date}:current`,
                                    origin: 'action'
                                }
                            )
                            : [];

                        const combinedTargets = this.dedupeTargets([...previousTargets, ...currentTargets]);
                        if (combinedTargets.length) {
                            const firstTarget = combinedTargets[0];
                            const action = {
                                label: this.$t('relatorio_destacar_repeticao'),
                                date: entity.previousDate || entity.date || null,
                                sequencial: firstTarget?.sequencial || null,
                                plateId: firstTarget?.plateId || null,
                                highlightType: 'conflict',
                                highlightTargets: combinedTargets,
                                focusTarget: firstTarget
                            };
                            view.lines = [{
                                type: 'r4-details',
                                items: [
                                    this.buildEntityRow(this.$t('relatorio_entidade_ingrediente'), entity.ingredient, {
                                        codeLabel: false,
                                        singleLine: true
                                    }),
                                    {
                                        label: this.$t('relatorio_entidade_tipo'),
                                        type: 'text',
                                        value: entity.tipo || '-',
                                        valueTitle: entity.tipo || '-'
                                    },
                                    {
                                        label: this.$t('date'),
                                        type: 'text',
                                        value: `${this.formatDate(entity.previousDate)} → ${this.formatDate(entity.date)}`,
                                        valueTitle: `${this.formatDate(entity.previousDate)} → ${this.formatDate(entity.date)}`
                                    }
                                ],
                                action
                            }];
                        }
                    }
                    break;
                case 'R5':
                    view.rows = [
                        { label: this.$t('relatorio_entidade_complexidade'), value: entity.complexityLevel || '-' },
                        this.buildUsageRow(this.$t('relatorio_entidade_uso'), entity.usage)
                    ];
                    view.lines = (Array.isArray(entity.contexts) ? entity.contexts : []).map((context, contextIndex) => {
                        const highlightTargets = this.buildR5ContextTargets(context);
                        const action = highlightTargets.length
                            ? {
                                label: this.$t('relatorio_destacar_incidencias'),
                                highlightType: 'usage',
                                highlightTargets,
                                focusTarget: highlightTargets[0] || null
                            }
                            : null;
                        return {
                            type: 'r5-details',
                            items: [
                                {
                                    label: this.$t('relatorio_entidade_tipo'),
                                    value: context?.tipo || '-',
                                    valueTitle: context?.tipo || '-'
                                },
                                {
                                    label: this.$t('date'),
                                    value: this.formatDate(context?.date),
                                    valueTitle: this.formatDate(context?.date)
                                },
                                {
                                    label: this.$t('relatorio_alta'),
                                    value: `${context?.altaCount ?? 0}/${context?.totalCount ?? 0}`,
                                    valueTitle: `${context?.altaCount ?? 0}/${context?.totalCount ?? 0}`
                                },
                                {
                                    label: this.$t('relatorio_limite'),
                                    value: this.formatPercent(context?.threshold),
                                    valueTitle: this.formatPercent(context?.threshold)
                                }
                            ],
                            action,
                            key: `r5-${contextIndex}`
                        };
                    });
                    break;
                case 'R6':
                    view.rows = [
                        { label: this.$t('date'), value: this.formatDate(entity.date) },
                        this.buildEntityRow(this.$t('relatorio_entidade_coluna'), entity.column),
                        this.buildEntityRow(this.$t('relatorio_entidade_prato'), entity.plate),
                        { label: this.$t('pre_preparation'), value: this.formatBoolean(entity.dayAllowsPrePrep) }
                    ];
                    if (entity.date) view.actions.push({ date: entity.date, sequencial: entity.column?.id, plateId: entity.plate?.id, highlightType: 'conflict' });
                    break;
                case 'R7':
                    view.rows = [
                        { label: this.$t('date'), value: this.formatDate(entity.date) },
                        this.buildEntityRow(this.$t('group_of_dishes'), entity.group),
                        this.buildEntityRow(this.$t('plates'), entity.plate)
                    ];
                    view.tags = entity.restrictionsTriggered || [];
                    if (entity.date) view.actions.push({ date: entity.date, plateId: entity.plate?.id, highlightType: 'conflict' });
                    break;
                case 'R8':
                    if (entity.scope === 'MONTH') {
                        const r8Category = this.getR8EntityCategory(entity);
                        const requiredLabel = this.getR8RequiredEntityLabel(entity);
                        if (r8Category === 'UNREALIZED') {
                            view.rows = [
                                this.buildEntityRow(this.$t('relatorio_entidade_pivo'), entity.pivot, {
                                    codeLabel: false,
                                    singleLine: true
                                }),
                                this.buildEntityRow(requiredLabel, entity.requiredItem, {
                                    codeLabel: false,
                                    singleLine: true
                                })
                            ];
                        } else {
                            view.rows = [
                                this.buildEntityRow(this.$t('relatorio_entidade_pivo'), entity.pivot, {
                                    codeLabel: false,
                                    singleLine: true
                                }),
                                { label: this.$t('date'), value: this.formatDate(entity.date) }
                            ];
                        }
                        if (r8Category !== 'UNREALIZED') {
                            view.tags = (entity.missingItems || []).map(item => this.getEntityLabel(item));
                        }
                        const candidateTargets = this.buildR8CandidateTargets(entity, 'pivot');
                        if (candidateTargets.length) {
                            view.actions.push({
                                label: this.$t('relatorio_destacar_oportunidades'),
                                highlightType: 'candidate',
                                highlightTargets: candidateTargets
                            });
                        }
                    } else {
                        view.rows = [
                            this.buildEntityRow(this.$t('relatorio_entidade_pivo'), entity.pivot, {
                                codeLabel: false,
                                singleLine: true
                            }),
                            { label: this.$t('date'), value: this.formatDate(entity.date) }
                        ];
                        view.tags = (entity.missingItems || []).map(item => this.getEntityLabel(item));
                        const candidateTargets = this.buildR8CandidateTargets(entity, 'required');
                        if (candidateTargets.length) {
                            view.actions.push({
                                label: this.$t('relatorio_r8_destacar_oportunidades_obrigatorio'),
                                highlightType: 'candidate',
                                highlightTargets: candidateTargets
                            });
                        }
                    }
                    break;
                case 'R9':
                    {
                        const conflictTargets = this.buildR9ConflictTargets(entity);
                        const action = conflictTargets.length
                            ? {
                                label: this.$t('relatorio_destacar_conflito'),
                                highlightType: 'conflict',
                                highlightTargets: conflictTargets
                            }
                            : (entity.date ? {
                                label: this.$t('relatorio_destacar_conflito'),
                                date: entity.date,
                                highlightType: 'conflict'
                            } : null);

                        view.lines = [
                            {
                                type: 'r9-summary',
                                items: [
                                    {
                                        label: this.$t('relatorio_entidade_conflito'),
                                        value: this.formatR9ConflictType(entity.conflictType)
                                    },
                                    {
                                        label: this.$t('date'),
                                        value: this.formatDate(entity.date)
                                    }
                                ]
                            },
                            {
                                type: 'r9-details',
                                items: [
                                    this.buildEntityRow(this.$t('relatorio_entidade_lado_esquerdo'), entity.left, {
                                        codeLabel: false,
                                        singleLine: true
                                    }),
                                    this.buildEntityRow(this.$t('relatorio_entidade_lado_direito'), entity.right, {
                                        codeLabel: false,
                                        singleLine: true
                                    })
                                ],
                                action
                            }
                        ];
                    }
                    break;
                case 'R10':
                    {
                        const dishTypeName = this.getR10DishTypeName(entity);
                        view.rows = [
                            {
                                label: this.$t('relatorio_entidade_tipo'),
                                value: dishTypeName || '-',
                                valueTitle: dishTypeName || '-',
                                singleLine: true
                            },
                            { label: this.$t('date'), value: this.formatDate(entity.date) },
                            { label: this.$t('relatorio_entidade_coluna'), value: this.formatColumnDisplay(entity.column) }
                        ];

                        view.tags = this.getR10DishGroups(entity);
                    }
                    if (entity.date) {
                        const occurrenceTargets = this.buildTargetsFromIssueTargets([
                            {
                                date: entity.date,
                                sequencial: entity.column?.id,
                                plateId: null
                            }
                        ], null, 'usage');
                        view.actions.push({
                            label: this.$t('relatorio_exibir_ocorrencia'),
                            date: entity.date,
                            sequencial: entity.column?.id,
                            highlightType: 'usage',
                            highlightTargets: occurrenceTargets
                        });
                    }
                    break;
                default:
                    view.fallback = true;
                    break;
            }

            return view;
        },
        emitNavigateFromEntity(date, sequencial, plateId, ruleId, source = 'issue') {
            const normalizedDate = this.normalizeDateForMenu(date);
            if (!normalizedDate) return;

            this.$emit('navigate-to-menu', {
                date: normalizedDate,
                sequencial: this.normalizeSequencial(sequencial),
                plateId: plateId ? String(plateId) : null,
                ruleId: ruleId || null,
                source
            });

            if (this.autoCloseOnNavigate) {
                this.fecharModal();
            }
        },
        fecharModal() {
            this.$modal.hide('RelatorioIAModal');
        },
        setLoadingState(value, options = {}) {
            const { emit = true } = options;
            this.loading = value;
            if (emit) {
                this.$emit('report-loading-change', value);
            }
        },
        getRelatorioRowsFromResponse(relatorioResponse) {
            if (!Array.isArray(relatorioResponse) || relatorioResponse.length === 0) {
                return [];
            }

            const [firstItem] = relatorioResponse;

            if (Array.isArray(firstItem)) {
                return firstItem;
            }

            if (firstItem && typeof firstItem === 'object') {
                return relatorioResponse;
            }

            if (typeof firstItem === 'string') {
                return [{ METADATAJSON: firstItem }];
            }

            return [];
        },
        async carregarRelatorio(regerar = false, options = {}) {
            const { silent = false } = options;
            if (!this.scenarioId) {
                if (!silent) {
                    this.errorMessage = this.$t('relatorio_erro_sem_id');
                }
                this.setLoadingState(false, { emit: !silent });
                return;
            }

            if (this.requestInFlight) {
                if (!silent && this.requestInFlightSilent) {
                    this.promotedSilentRequestToVisible = true;
                    this.setLoadingState(true, { emit: true });
                }
                return this.requestInFlight;
            }

            if (!regerar) {
                if (this.isReportCompatibleWithCurrentScenario(this.relatorioData)) {
                    this.setCurrentContextLoadState('loaded');
                    return;
                }
                const contextState = this.getCurrentContextLoadState();
                if (contextState === 'missing' && silent) {
                    return;
                }
            }

            this.requestInFlightSilent = !!silent;
            this.promotedSilentRequestToVisible = false;

            if (!silent) {
                this.setLoadingState(true, { emit: true });
            }
            if (!silent) {
                this.errorMessage = null;
            }
            const requestPromise = (async () => {
                const relatorioResponse = await PlatesService.verificaRelatorioIA(
                    this.scenarioId,
                    this.dataCatalog,
                    regerar
                );
                const relatorioRows = this.getRelatorioRowsFromResponse(relatorioResponse);

                if (!relatorioRows || relatorioRows.length === 0) {
                    this.setReportStatusState('MISSING', {
                        scenarioVersion: this.scenarioVersion,
                        reportVersion: null
                    });
                    if (regerar) {
                        this.relatorioData = null;
                    }
                    this.setCurrentContextLoadState('missing');
                    return;
                }

                const relatorioRow = relatorioRows[0] || {};
                const backendScenarioVersion = this.normalizeContextValue(relatorioRow?.VERSAOCENARIOATUAL)
                    || this.normalizeContextValue(this.scenarioVersion);
                const backendReportVersion = this.normalizeContextValue(relatorioRow?.VERSAORELATORIOIA);
                const metadata = relatorioRow?.METADATAJSON;
                if (!metadata) {
                    const statusWithoutMetadata = this.resolveReportStatus(relatorioRow, null);
                    this.setReportStatusState(statusWithoutMetadata, {
                        scenarioVersion: backendScenarioVersion,
                        reportVersion: backendReportVersion
                    });
                    if (regerar) {
                        this.relatorioData = null;
                    }
                    this.setCurrentContextLoadState('missing');
                    return;
                }

                const parsedReport = JSON.parse(metadata);
                const resolvedStatus = this.resolveReportStatus(relatorioRow, parsedReport);
                this.setReportStatusState(resolvedStatus, {
                    scenarioVersion: backendScenarioVersion,
                    reportVersion: backendReportVersion || this.normalizeContextValue(parsedReport?.metadata?.scenario?.version)
                });

                if (!this.isReportCompatibleWithCurrentScenario(parsedReport, resolvedStatus)) {
                    this.relatorioData = null;
                    this.setCurrentContextLoadState('missing');
                    return;
                }

                this.relatorioData = parsedReport;
                this.errorMessage = null;
                this.setCurrentContextLoadState('loaded');
            })().catch((error) => {
                console.error('Erro ao carregar relatório:', error);
                this.setCurrentContextLoadState('error');
                if (!silent) {
                    this.errorMessage = error.message || this.$t('relatorio_erro_geral');
                }
            }).finally(() => {
                if (silent) {
                    if (this.promotedSilentRequestToVisible) {
                        this.setLoadingState(false, { emit: true });
                    } else {
                        this.loading = false;
                    }
                } else {
                    this.setLoadingState(false, { emit: true });
                }
                this.requestInFlight = null;
                this.requestInFlightSilent = false;
                this.promotedSilentRequestToVisible = false;
            });

            this.requestInFlight = requestPromise;
            return requestPromise;
        },
        gerarRelatorio() {
            this.clearMenuHighlights();
            this.carregarRelatorio(true, { silent: false });
        },
        async regerarCardapio() {
            this.loadingCardapio = true;
            this.erroCardapio = null;
            try {
                // TODO: substituir por chamada real à API de geração de cardápio com IA
                // const newCardData = await PlatesService.regerarCardapioIA();
                const newCardData = await Promise.resolve(null);
                this.$emit('cardapio-regenerado', { scenarioId: this.scenarioId });
                this.fecharModal();
            } catch (_error) {
                this.erroCardapio = this.$t('regerar_cardapio_erro');
            } finally {
                this.loadingCardapio = false;
            }
        }
    },
    beforeDestroy() {
        this.$emit('report-loading-change', false);
    }
};
</script>

<style scoped lang="less">
@import (reference) url("../../../assets/variables.less");

.relatorio-modal-wrapper {
    width: calc(100% - 40px);
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 20px;
    max-height: 85vh;
}

.title {
    margin: 0;
    color: #212146;
    font-size: 1.5rem;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    gap: 10px;
}

.report-status-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 12px;
    padding: 2px 10px;
    font-size: 0.75rem;
    font-weight: 700;
    letter-spacing: 0.02em;
    text-transform: uppercase;
}

.report-status-badge.deprecated {
    background: #e3f2fd;
    border: 1px solid #64b5f6;
    color: #1565c0;
}

.loading-container {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 60px 20px;
    min-height: 300px;

    p {
        color: #666;
        font-size: 1.1rem;
    }
}

.relatorio-content {
    background: white;
    border: 1px solid #e0e0e0;
    border-radius: 6px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    flex: 1;
}

.no-data-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px 20px;
    text-align: center;
    background: #f8f9fa;
    border-radius: 8px;
    border: 1px solid #e0e0e0;
    min-height: 300px;

    &.error {
        background: #FFF5F5;
        border-color: #FFCDD2;

        .no-data-icon {
            color: #F44336;
        }
    }
}

.no-data-icon {
    font-size: 3rem;
    margin-bottom: 20px;
    color: #2196F3;
}

.no-data-content h4 {
    color: #212146;
    margin-bottom: 10px;
    font-size: 1.2rem;
}

.no-data-content p {
    color: #666;
    margin-bottom: 25px;
    max-width: 500px;
    line-height: 1.5;
}

.tabs {
    display: flex;
    flex-direction: column;
    height: 100%;
}

.tabs-header {
    display: flex;
    background: #f8f9fa;
    border-bottom: 1px solid #e0e0e0;
    flex-shrink: 0;
}

.tab-button {
    padding: 12px 24px;
    background: none;
    border: none;
    border-bottom: 2px solid transparent;
    font-size: 1rem;
    color: #666;
    cursor: pointer;
    transition: all 0.2s ease;
    white-space: nowrap;

    &:hover:not(.active) {
        background: #f0f0f0;
    }

    &.active {
        color: #212146;
        border-bottom-color: #212146;
        font-weight: 600;
        background: white;
    }
}

.tabs-content {
    padding: 20px;
    flex: 1;
    overflow-y: auto;
    max-height: calc(85vh - 200px);
}

.tab-pane {
    display: flex;
    flex-direction: column;
    gap: 25px;
}

.tab-section {
    h4 {
        margin: 0 0 15px 0;
        color: #212146;
        font-size: 1.1rem;
        border-bottom: 2px solid #f0f0f0;
        padding-bottom: 8px;
    }
}

.metadata-container {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    gap: 12px;
    background: #f8f9fa;
    padding: 15px;
    border-radius: 6px;
}

.metadata-item {
    display: flex;
    flex-direction: column;

    // Em caso de querer alinhar horizontalmente ao invés de exibir um em cima do outro, comentar a flex-direction column e descomentar essas linhas abaixo
    // align-items: baseline;
    // gap: 6px;
}

.metadata-label {
    font-size: 0.85rem;
    color: #666;
    font-weight: 500;
    margin-bottom: 2px;
}

.metadata-value {
    font-size: 0.95rem;
    color: #212146;
    font-weight: 500;
    word-break: break-word;
}

.score-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;

    @media (min-width: 768px) {
        flex-direction: row;
        align-items: center;
    }
}

.score-circle {
    width: 120px;
    height: 120px;
    border-radius: 50%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    &.excellent {
        background: linear-gradient(135deg, #4CAF50, #8BC34A);
        color: white;
    }

    &.good {
        background: linear-gradient(135deg, #2196F3, #03A9F4);
        color: white;
    }

    &.regular {
        background: linear-gradient(135deg, #FF9800, #FFC107);
        color: white;
    }

    &.poor {
        background: linear-gradient(135deg, #F44336, #FF5722);
        color: white;
    }
}

.score-value {
    font-size: 2.5rem;
    font-weight: bold;
    line-height: 1;
}

.score-label {
    font-size: 0.9rem;
    opacity: 0.9;
}

.score-details {
    flex: 1;
}

.score-before-block {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
    opacity: 0.65;
}

.score-label-context {
    font-size: 0.7rem;
    font-weight: 700;
    letter-spacing: 0.08em;
    color: #454545;
    text-transform: uppercase;
}

.score-before-subtitle {
    font-size: 0.75rem;
    color: #454545;
}

.score-circle-before {
    width: 90px;
    height: 90px;
    border-radius: 50%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border: 3px solid #0192d0;
    background: transparent;
}

.score-circle-before .score-value {
    font-size: 2rem;
    font-weight: 700;
    line-height: 1;
    color: #0192d0;
}

.score-circle-before .score-label {
    font-size: 0.75rem;
    color: #0192d0;
}

.score-arrow-block {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
    color: #4CAF50;
    font-weight: 700;
}

.score-arrow {
    font-size: 1.5rem;
}

.score-delta {
    font-size: 0.85rem;
    background: rgba(76, 175, 80, 0.15);
    padding: 2px 8px;
    border-radius: 12px;
}

.quality-level {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 15px;
}

.quality-label {
    font-size: 0.95rem;
    color: #666;
}

.quality-value {
    padding: 4px 10px;
    border-radius: 12px;
    font-size: 0.85rem;
    font-weight: 600;

    &.excellent {
        background: #E8F5E9;
        color: #2E7D32;
    }

    &.good {
        background: #E3F2FD;
        color: #1565C0;
    }

    &.regular {
        background: #FFF3E0;
        color: #EF6C00;
    }

    &.poor {
        background: #FFEBEE;
        color: #C62828;
    }
}

.summary-text {
    font-size: 1rem;
    color: #555;
    line-height: 1.5;
    padding: 12px;
    background: #f8f9fa;
    border-radius: 6px;
    border-left: 4px solid #212146;
}

.issues-summary {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 15px;
}

.issue-count {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px 10px;
    border-radius: 8px;
    text-align: center;

    &.critical {
        background: #FFEBEE;
        border: 1px solid #F44336;
    }

    &.medium {
        background: #FFF1E6;
        border: 1px solid #FB8C00;
    }

    &.low {
        background: #FFFDE7;
        border: 1px solid #FBC02D;
    }
}

.issue-count-number {
    font-size: 2rem;
    font-weight: bold;
    margin-bottom: 5px;

    .critical & {
        color: #F44336;
    }

    .medium & {
        color: #EF6C00;
    }

    .low & {
        color: #F9A825;
    }
}

.issue-count-label {
    font-size: 0.9rem;
    font-weight: 600;
    color: #555;
}

.detailed-analysis,
.other-analysis {
    display: flex;
    flex-direction: column;
    gap: 25px;
}

.analysis-section,
.other-section {
    background: white;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    overflow: hidden;
}

.section-header,
.section-title {
    padding: 15px 20px;
    margin: 0;
    background: #f8f9fa;
    border-bottom: 1px solid #e0e0e0;
    color: #212146;
    font-size: 1rem;
    display: flex;
    align-items: center;
    gap: 10px;

    h4 {
        margin: 0;
        display: flex;
        align-items: center;
        gap: 10px;
        width: 100%;
    }

    i.fa-exclamation-circle {
        color: #F44336;
    }

    i.fa-clipboard-check {
        color: #4CAF50;
    }

    i.fa-lightbulb {
        color: #FF9800;
    }

    i.fa-brain {
        color: #9C27B0;
    }
}

.counter-badge {
    background: #212146;
    color: white;
    padding: 2px 8px;
    border-radius: 12px;
    font-size: 0.75rem;
    font-weight: 600;
    margin-left: auto;
}

.highlight-legend-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 8px;
    padding: 10px 15px 0 15px;
}

.highlight-legend {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 6px;
}

.legend-title {
    color: #4b5578;
    font-size: 0.78rem;
    font-weight: 600;
}

.legend-item {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 2px 8px;
    border-radius: 10px;
    font-size: 0.72rem;
    color: #2d3658;
    background: #f4f6fb;
    border: 1px solid #d6deef;

    &::before {
        content: "";
        width: 8px;
        height: 8px;
        border-radius: 50%;
        display: block;
        background: #c62828;
    }
}

.legend-item.legend-usage::before {
    background: #2e7d32;
}

.legend-item.legend-candidate::before {
    background: #f9a825;
}

.legend-item.legend-conflict::before {
    background: #c62828;
}

.clear-highlights-btn {
    border: 1px solid #9ca7cd;
    border-radius: 6px;
    background: #f7f9ff;
    color: #2a3357;
    font-size: 0.75rem;
    font-weight: 600;
    padding: 4px 10px;
    cursor: pointer;
    transition: background 0.2s ease, border-color 0.2s ease;

    &:hover {
        background: #edf2ff;
        border-color: #7f90c6;
    }
}

.items-list,
.other-list {
    padding: 15px;
}

.list-item,
.other-item {
    padding: 12px;
    border-radius: 6px;
    margin-bottom: 10px;

    &:last-child {
        margin-bottom: 0;
    }

    &.critical {
        background: #FFF5F5;
        border: 1px solid #FFCDD2;
        border-left: 3px solid #F44336;
    }

    &.medium {
        background: #FFF1E6;
        border: 1px solid #FFD3A8;
        border-left: 3px solid #FB8C00;
    }

    &.low {
        background: #FFFDE7;
        border: 1px solid #FFE082;
        border-left: 3px solid #FBC02D;
    }

    &.compliant {
        background: #F1F8E9;
        border: 1px solid #C8E6C9;
        border-left: 3px solid #4CAF50;
    }

    &.violated {
        background: #FFF5F5;
        border: 1px solid #FFCDD2;
        border-left: 3px solid #F44336;
    }

    &.partial {
        background: #FFF3E0;
        border: 1px solid #FFECB3;
        border-left: 3px solid #FF9800;
    }
}

.item-header {
    display: flex;
    gap: 12px;
    align-items: flex-start;
}

.item-icon {
    // flex-shrink: 0;
    // width: 24px;
    // min-width: 24px;
    max-width: 24px;
    // height: 24px;
    // min-height: 24px;
    max-height: 24px;
    aspect-ratio: 1 / 1;
    border-radius: 50%;
    display: grid;
    place-items: center;
    // margin-top: 1px;
    color: white;
    // box-sizing: border-box;
    // overflow: hidden;
    padding: 4px;

    .critical & {
        background: #F44336;
    }

    .medium & {
        background: #FB8C00;
    }

    .low & {
        background: #FBC02D;
    }

    &.compliant {
        background: #4CAF50;
    }

    &.violated {
        background: #F44336;
    }

    &.partial {
        background: #FF9800;
    }

    i {
        font-size: 12px;
        line-height: 1;
        width: 1em;
        text-align: center;
        display: block;
    }
}

.item-content {
    flex: 1;
}

.item-title {
    font-weight: 600;
    color: #212146;
    font-size: 0.95rem;
    margin-bottom: 5px;
    line-height: 1.3;
}

.item-description {
    color: #666;
    font-size: 0.85rem;
    line-height: 1.4;
}

.issue-accordion-header,
.rule-accordion-header {
    width: 100%;
    border: none;
    background: transparent;
    padding: 0;
    text-align: left;
    cursor: pointer;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
}

.issue-header-right {
    display: flex;
    align-items: center;
    gap: 8px;
    color: #666;
    font-size: 0.75rem;
    flex-shrink: 0;
}

.accordion-chevron {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    min-width: 16px;
    line-height: 1;
    color: #616161;
}

.accordion-chevron i {
    font-size: 12px;
    line-height: 1;
}

.entity-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 2px 8px;
    border-radius: 10px;
    background: #eef2ff;
    color: #212146;
    font-size: 0.72rem;
    font-weight: 600;
    white-space: nowrap;
}

.issue-accordion-body,
.rule-accordion-body {
    margin-top: 12px;
    padding-top: 12px;
    border-top: 1px dashed rgba(33, 33, 70, 0.2);
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.entity-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.entity-card {
    border: 1px solid #dfe3ef;
    border-radius: 8px;
    padding: 10px;
    background: #fff;
}

.entity-card.entity-card-collapsible {
    padding: 0;
    overflow: hidden;
}

.entity-accordion-header {
    width: 100%;
    border: 0;
    background: #f7f9ff;
    color: #1f2446;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 12px;
    cursor: pointer;
}

.entity-accordion-title {
    font-size: 0.82rem;
    font-weight: 700;
    text-align: left;
}

.entity-accordion-right {
    display: inline-flex;
    align-items: center;
    gap: 8px;
}

.entity-card-body {
    padding: 10px;
}

.entity-display {
    display: flex;
}

.entity-display.entity-display-r1-frequency,
.entity-display-r1-frequency {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    gap: 12px;
    align-items: center;
    width: 100%;
}

.entity-display-r1-frequency > .entity-grid {
    grid-template-columns: repeat(3, minmax(220px, 1fr));
    gap: 10px;
}

.entity-display-r1-frequency > .entity-actions {
    margin-top: 0;
    justify-content: flex-end;
    align-items: center;
    align-self: center;
    flex-wrap: nowrap;
    white-space: nowrap;
}

.entity-display.entity-display-r3-repetition,
.entity-display-r3-repetition {
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
    padding-right: 8px;
    box-sizing: border-box;
}

.r3-summary-grid {
    grid-template-columns: repeat(2, minmax(220px, 1fr));
    gap: 10px;
}

.r3-tags-actions-row {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    column-gap: 10px;
    row-gap: 8px;
    align-items: center;
    width: 100%;
}

.r3-tags-row {
    margin-top: 0;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 6px;
    min-width: 0;
}

.r3-actions-row {
    display: flex;
    margin-top: 0;
    justify-content: flex-end;
    align-items: center;
    align-self: center;
    flex-wrap: nowrap;
    white-space: nowrap;
}

.entity-display.entity-display-r8-unmet,
.entity-display-r8-unmet {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    grid-template-areas:
        "grid grid"
        "tags actions"
        "lines lines";
    column-gap: 10px;
    row-gap: 8px;
    align-items: start;
    width: 100%;
}

.entity-display-r8-unmet>.entity-grid {
    grid-area: grid;
    grid-template-columns: repeat(2, minmax(220px, 1fr));
}

.entity-display-r8-unmet>.entity-tags {
    grid-area: tags;
    margin-top: 0;
}

.entity-display-r8-unmet>.entity-actions {
    grid-area: actions;
    margin-top: 0;
    justify-content: flex-end;
    align-self: start;
}

.entity-display-r8-unmet>.entity-lines {
    grid-area: lines;
    margin-top: 0;
}

.entity-display.entity-display-r10-gap,
.entity-display-r10-gap {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    grid-template-areas:
        "grid grid"
        "tags actions";
    column-gap: 10px;
    row-gap: 8px;
    align-items: start;
    width: 100%;
}

.entity-display-r10-gap>.entity-grid {
    grid-area: grid;
    grid-template-columns: repeat(3, minmax(190px, 1fr));
    gap: 10px;
}

.entity-display-r10-gap>.entity-tags {
    grid-area: tags;
    margin-top: 0;
}

.entity-display-r10-gap>.entity-actions {
    grid-area: actions;
    margin-top: 0;
    justify-content: flex-end;
    align-items: flex-start;
    align-self: start;
    flex-wrap: nowrap;
    white-space: nowrap;
}

.entity-display.entity-display-r9-conflict,
.entity-display-r9-conflict {
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    row-gap: 8px;
    width: 100%;
}

.entity-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(190px, 1fr));
    gap: 8px;
    width: 100%;
}

.entity-line {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;
    font-size: 0.8rem;
    color: #333;
    background: #f9fafc;
    border-radius: 6px;
    padding: 6px 8px;
}

.entity-grid .entity-line strong {
    margin-right: 2px;
    white-space: nowrap;
}

.entity-line.entity-line-entity,
.entity-line.entity-line-usage {
    flex-wrap: wrap;
}

.entity-line.entity-line-single-line {
    flex-wrap: nowrap;
    min-width: 0;
}

.entity-line.entity-line-single-line strong {
    flex: 0 0 auto;
}

.entity-value-entity {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
}

.entity-value-entity.entity-value-entity-single-line {
    flex: 1 1 auto;
    flex-wrap: nowrap;
    min-width: 0;
    overflow: hidden;
}

.entity-code-chip {
    font-size: 0.75rem;
    color: #4a5278;
    background: #e9edf8;
    border: 1px solid #d7dff2;
    border-radius: 10px;
    padding: 2px 8px;
    font-weight: 600;
}

.entity-value-name {
    font-size: 0.85rem;
    color: #1f2446;
    font-weight: 600;
}

.entity-value-name.entity-value-name-single-line {
    flex: 1 1 auto;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.entity-text-value-single-line {
    flex: 1 1 auto;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.entity-usage-metrics {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 6px;
}

.entity-lines .entity-line {
    justify-content: space-between;
}

.entity-line.entity-line-r9-summary,
.entity-line.entity-line-r9-details,
.entity-line.entity-line-r5-details,
.entity-line.entity-line-r4-details {
    background: transparent;
    border-radius: 0;
    padding: 0;
    display: block;
}

.r5-details-layout {
    width: 100%;
    background: #fff;
    border: 1px solid #dfe3ef;
    border-radius: 8px;
    padding: 10px;
}

.r5-details-grid {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr)) auto;
    gap: 12px;
    align-items: center;
    width: 100%;
}

.r5-detail-item {
    justify-content: flex-start !important;
}

.r5-detail-item strong {
    margin-right: 0;
}

.r5-detail-value {
    flex: 1 1 auto;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 0.85rem;
    color: #1f2446;
    font-weight: 600;
}

.r5-details-action {
    justify-self: end;
    white-space: nowrap;
}

.r9-summary-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
    width: 100%;
}

.r9-details-grid {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) auto;
    gap: 12px;
    align-items: center;
    width: 100%;
}

.r4-details-grid {
    display: grid;
    grid-template-columns: minmax(0, 1.1fr) minmax(0, 1fr) minmax(0, 1.1fr) auto;
    gap: 12px;
    align-items: center;
    width: 100%;
}

.r9-summary-item,
.r9-detail-item {
    justify-content: flex-start !important;
}

.r4-detail-item {
    justify-content: flex-start !important;
}

.r9-summary-item strong,
.r9-detail-item strong {
    margin-right: 0;
}

.r4-detail-item strong {
    margin-right: 0;
}

.r4-detail-value {
    flex: 1 1 auto;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 0.85rem;
    color: #1f2446;
    font-weight: 600;
}

.r9-details-action {
    justify-self: end;
    white-space: nowrap;
}

.r4-details-action {
    justify-self: end;
    white-space: nowrap;
}

.entity-line.entity-line-group-usage {
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 6px;
}

.r3-group-entities {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.r8-group-entities {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.r3-entity-card {
    background: #fff;
}

.group-usage-header {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
}

.group-name {
    font-size: 0.85rem;
    color: #1f2446;
    font-weight: 600;
}

.group-usage-metrics {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 6px;
}

.group-usage-actions {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
}

.group-usage-scope {
    font-size: 0.75rem;
    color: #42507b;
    background: #edf2ff;
    border: 1px solid #d7e2ff;
    border-radius: 10px;
    padding: 2px 8px;
    font-weight: 500;
}

.group-usage-chip {
    font-size: 0.75rem;
    color: #3c4665;
    background: #f3f5fa;
    border: 1px solid #dde2ee;
    border-radius: 10px;
    padding: 2px 8px;
}

.entity-lines {
    margin-top: 8px;
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.entity-tags {
    margin-top: 8px;
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
}

.entity-tag {
    background: #f2f5fb;
    color: #3b3f62;
    border: 1px solid #d5dbef;
    border-radius: 14px;
    padding: 3px 8px;
    font-size: 0.75rem;
}

.entity-tag-action {
    cursor: pointer;
    transition: background 0.2s ease, border-color 0.2s ease;
    font-family: inherit;

    &:hover {
        background: #e6ecfa;
        border-color: #becae8;
    }
}

.entity-actions {
    margin-top: 8px;
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
}

.navigate-btn {
    border: 1px solid #212146;
    border-radius: 6px;
    background: #212146;
    color: white;
    font-size: 0.75rem;
    padding: 4px 8px;
    cursor: pointer;
    transition: background 0.2s ease;

    white-space: nowrap;

    &:hover {
        background: #171736;
    }
}

.navigate-btn.navigate-btn-usage {
    background: #2e7d32;
    border-color: #2e7d32;

    &:hover {
        background: #276c2b;
    }
}

.navigate-btn.navigate-btn-candidate {
    background: #f9a825;
    border-color: #f9a825;
    color: #1f2446;

    &:hover {
        background: #e29a20;
    }
}

.navigate-btn.navigate-btn-conflict {
    background: #c62828;
    border-color: #c62828;

    &:hover {
        background: #a92222;
    }
}

.entity-fallback {
    font-size: 0.8rem;
    color: #555;

    pre {
        margin: 8px 0 0 0;
        white-space: pre-wrap;
        max-height: 220px;
        overflow: auto;
        background: #f8f9fb;
        border: 1px solid #e1e5f0;
        border-radius: 6px;
        padding: 8px;
    }
}

.entity-empty {
    font-size: 0.85rem;
    color: #666;
    background: #f9fafc;
    border: 1px dashed #d2d9ea;
    border-radius: 6px;
    padding: 10px;
}

.recommendation-item {
    background: #FFF3E0;
    border-left: 3px solid #FF9800;
}

.recommendation-priority {
    display: inline-block;
    padding: 2px 8px;
    border-radius: 10px;
    font-size: 0.75rem;
    font-weight: 600;
    margin-bottom: 8px;

    &.high {
        background: #FFEBEE;
        color: #C62828;
    }

    &.medium {
        background: #FFF3E0;
        color: #EF6C00;
    }

    &.low {
        background: #E8F5E9;
        color: #2E7D32;
    }
}

.recommendation-text {
    color: #212146;
    font-size: 0.9rem;
    line-height: 1.4;
    margin: 8px 0;
}

.signal-item {
    background: #F3E5F5;
    border-left: 3px solid #9C27B0;
}

.signal-header {
    margin-bottom: 8px;
}

.signal-type {
    font-weight: 600;
    color: #212146;
    font-size: 0.9rem;
}

.signal-description {
    color: #212146;
    font-size: 0.85rem;
    line-height: 1.4;
    margin: 8px 0;
}

.no-data-message {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px 20px;
    color: #888;
    text-align: center;
    background: #f8f9fa;
    border-radius: 8px;
    border: 1px dashed #e0e0e0;

    i {
        font-size: 3rem;
        margin-bottom: 15px;
        color: #4CAF50;
    }

    p {
        font-size: 1rem;
        color: #666;
        margin: 0;
    }
}

.modal-buttons {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 8px;
    flex-shrink: 0;
    padding-top: 20px;
    border-top: 1px solid #e7e7e7;
}

.modal-buttons-row {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    flex-wrap: wrap;
    width: 100%;
}

.cardapio-error-message {
    color: #dc143c;
    font-size: 0.85rem;
    margin: 0;
    text-align: right;
}

.button {
    padding: 8px 16px;
    border-radius: 4px;
    font-weight: 500;
    cursor: pointer;
    border: 1px solid transparent;
    display: flex;
    align-items: center;
    gap: 8px;
    transition: all 0.2s ease;
    white-space: nowrap;

    &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }
}

.ghost {
    background: white;
    color: #dc143d;
    border: 1px solid #dc143d;

    &:hover:not(:disabled) {
        background: #f8f8f8;
    }
}

.primary {
    background: #212146;
    color: white;

    &:hover:not(:disabled) {
        background: #1a1a38;
    }
}

.relatorio-sync-icon-wrapper {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 1em;
    height: 1em;
    transform-origin: center;
    will-change: transform;
}

.relatorio-sync-icon-wrapper.is-spinning {
    animation: relatorio-sync-spin 1s linear infinite !important;
}

.relatorio-sync-icon {
    display: inline-block;
    transform-origin: center;
}

@keyframes relatorio-sync-spin {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}

@media (max-width: 768px) {
    .relatorio-modal-wrapper {
        padding: 15px;
        max-height: 90vh;
    }

    .tabs-content {
        padding: 15px;
        max-height: calc(90vh - 180px);
    }

    .modal-buttons {
        flex-direction: column;

        .button {
            width: 100%;
            justify-content: center;
        }
    }

    .score-container {
        flex-direction: column;
        text-align: center;
    }

    .quality-level {
        flex-direction: column;
        align-items: center;
        gap: 5px;
    }

    .issues-summary {
        grid-template-columns: 1fr;
    }

    .entity-display-r8-unmet {
        grid-template-columns: 1fr;
        grid-template-areas:
            "grid"
            "tags"
            "actions"
            "lines";
    }

    .entity-display-r8-unmet>.entity-grid {
        grid-template-columns: 1fr;
    }

    .entity-display-r8-unmet>.entity-actions {
        justify-content: flex-start;
    }

    .entity-display-r1-frequency {
        grid-template-columns: 1fr;
    }

    .entity-display-r1-frequency>.entity-grid {
        grid-template-columns: 1fr;
    }

    .entity-display-r1-frequency>.entity-actions {
        justify-content: flex-start;
    }

    .entity-display-r10-gap {
        grid-template-columns: 1fr;
        grid-template-areas:
            "grid"
            "tags"
            "actions";
    }

    .entity-display-r10-gap>.entity-grid {
        grid-template-columns: 1fr;
    }

    .entity-display-r10-gap>.entity-actions {
        justify-content: flex-start;
    }

    .entity-display-r3-repetition {
        grid-template-columns: 1fr;
    }

    .r3-summary-grid {
        grid-template-columns: 1fr;
    }

    .r3-tags-actions-row {
        grid-template-columns: 1fr;
    }

    .r3-actions-row {
        justify-content: flex-start;
    }

    .entity-display-r10-gap {
        grid-template-columns: 1fr;
    }

    .entity-display-r10-gap>.entity-grid {
        grid-template-columns: 1fr;
    }

    .entity-display-r10-gap>.entity-actions {
        justify-content: flex-start;
    }

    .r5-details-grid,
    .r9-summary-grid,
    .r9-details-grid,
    .r4-details-grid {
        grid-template-columns: minmax(0, 1fr);
    }

    .r5-details-action,
    .r9-details-action {
        justify-self: flex-start;
    }

    .r4-details-action {
        justify-self: flex-start;
    }
}

@media (max-width: 480px) {
    .tabs-header {
        flex-direction: column;

        .tab-button {
            width: 100%;
            text-align: center;
        }
    }

    .metadata-container {
        grid-template-columns: 1fr;
    }
}
</style>
